document.addEventListener('DOMContentLoaded', function() {
   $('.ski-dropdown').select2();
});


        const airlines = {
            "American": {
                "carryOnWeightLimit": " No weight limit ",
                "checkedBagWeightLimit": "50 lbs / 22 kg",
            },
            "Delta": {
                "carryOnWeightLimit": " No weight limit ",
                "checkedBagWeightLimit": "50 lbs / 22 kg"
            },
            "Southwest": {
                "carryOnWeightLimit": " No weight limit ",
                "checkedBagWeightLimit": "50 lbs / 22 kg "
            },
            "United": {
                "carryOnWeightLimit": " No weight limit ",
                "checkedBagWeightLimit": "50 lbs / 22 kg"
            },
            "Frontier": {
                "carryOnWeightLimit": " Max 35 lbs",
                "checkedBagWeightLimit": " 50 lbs / 22 kg "
            },
            "Spirit": {
                "carryOnWeightLimit": " No weight limit ",
                "checkedBagWeightLimit": " 40 lbs / 18 kg"
            },
            "Allegiant": {
                "carryOnWeightLimit": " Max 25 lbs / 11 kg",
                "checkedBagWeightLimit": " 40 lbs / 18 kg "
            },
            "JetBlue": {
                "carryOnWeightLimit": " No weight limit ",
                "checkedBagWeightLimit": " 50 lbs / 22 kg "
            },
            "AlaskaAir": {
                "carryOnWeightLimit": " No weight limit ",
                "checkedBagWeightLimit": "50 lbs / 22 kg "
            },
            "Hawaiian": {
                "carryOnWeightLimit": " Max 25 lbs / 11 kg",
                "checkedBagWeightLimit": " 50 lbs / 22 kg "
            },
            "BritishAir": {
                "carryOnWeightLimit": " Max 51 lbs / 23kg",
                "checkedBagWeightLimit": " 50 lbs / 22 kg"
            },
            "AirCanada": {
                "carryOnWeightLimit": " No weight limit ",
                "checkedBagWeightLimit": " 50 lbs / 22 kg "
            },
            "Qantas": {
                "carryOnWeightLimit": " up to 22 lbs / 10kgs ",
                "checkedBagWeightLimit": " up to 23kg /50lb  "
            },
            "Emirates": {
                "carryOnWeightLimit": " Max 15 lbs / 7kg",
                "checkedBagWeightLimit": " 50 lbs / 22 kg "
            },
            "QatarAir": {
                "carryOnWeightLimit": " Max 15lb/ 7kg ",
                "checkedBagWeightLimit": " 2 bags (50 lbs per bag) "
            },
            "TurkishAir": {
                "carryOnWeightLimit": " Max 18 lbs / 8 kg",
                "checkedBagWeightLimit": " 44 lbs / 19 kg "
            },
            "Lufthansa": {
                "carryOnWeightLimit": " Max 18 lbs / 8 kg",
                "checkedBagWeightLimit": " 50 lbs / 22 kg "
            },
            "AirFrance": {
                "carryOnWeightLimit": " Max 18 kg / 40 lb",
                "checkedBagWeightLimit": " 50 lbs / 22 kg "
            },

            "AegeanAirlines": {
                "carryOnWeightLimit": " up to 17 lbs / 8 kg",
                "checkedBagWeightLimit": " 50 lbs / 23 kg"
            },
            "AirAsia": {
                "carryOnWeightLimit": " Max 15.4 lbs / 7 kg ",
                "checkedBagWeightLimit": " 44 lbs / 20 kg "
            },
            "AirChina": {
                "carryOnWeightLimit": " up to 11 lbs / 5 kg ",
                "checkedBagWeightLimit": " 50 lbs / 23 kg"
            },
            "AirTransat": {
                "carryOnWeightLimit": " Max 22 lbs / 10 kg  ",
                "checkedBagWeightLimit": " 50 lbs / 23 kg"
            },
            "Alitalia": {
                "carryOnWeightLimit": " Max 11 lb / 5 kg ",
                "checkedBagWeightLimit": " 50 lbs / 23 kg "
            },
            "CathayPacific": {
                "carryOnWeightLimit": " Max 15 lb / 7 kg  ",
                "checkedBagWeightLimit": " 50 lbs / 23 kg"
            },
            "EasyJet": {
                "carryOnWeightLimit": " No weight limit",
                "checkedBagWeightLimit": " max 70 lbs (32 kg) "
            },
            "FlairAirlines": {
                "carryOnWeightLimit": " No weight limit ",
                "checkedBagWeightLimit": " 50 lbs / 23 kg"
            },
            "JapanAirlines": {
                "carryOnWeightLimit": " 22 lbs / 10 kg ",
                "checkedBagWeightLimit": " 50 lbs / 23 kg "
            },
            "Jetstar": {
                "carryOnWeightLimit": " 15 lbs / 7 kg",
                "checkedBagWeightLimit": " 44 lbs / 20 kg "
            },
            "KoreanAir": {
                "carryOnWeightLimit": " 18 kg/40 lbs. ",
                "checkedBagWeightLimit": " 50 lbs / 23 kg"
            },
            "PorterAirlines": {
                "carryOnWeightLimit": " 9 kg / 20 lb",
                "checkedBagWeightLimit": " 50 lbs / 23 kg"
            },
            "Ryanair": {
                "carryOnWeightLimit": " 22 lbs / 10 kg ",
                "checkedBagWeightLimit": " 44 lbs / 20 kg "
            },
            "SasAirlines": {
                "carryOnWeightLimit": " 17 lbs / 8 kg ",
                "checkedBagWeightLimit": " 50 lbs / 23 kg "
            },
            "SingaporeAirlines": {
                "carryOnWeightLimit": " up to 7 kg / 15 lbs",
                "checkedBagWeightLimit": " 50 lbs / 23 kg "
            },
            "SunCountry": {
                "carryOnWeightLimit": "35 lbs / 16 kg ",
                "checkedBagWeightLimit": "50 lbs /  23 kg "
            },
            "SwissAirlines": {
                "carryOnWeightLimit": " 18 lbs / 8 kg",
                "checkedBagWeightLimit": " 50 lbs / 23 kg"
            },
            "Swoop": {
                "carryOnWeightLimit": " No weight limit",
                "checkedBagWeightLimit": "50 lbs / 23 kg  "
            },
            "ThaiAirways": {
                "carryOnWeightLimit": "  7 kg/15 lbs ",
                "checkedBagWeightLimit": "50 lbs / 23 kg "
            },
            "TuiAirways": {
                "carryOnWeightLimit": " 11 lbs / 5 kg ",
                "checkedBagWeightLimit": " 44 lbs / 20 kg"
            },
            "VirginAtlantic": {
                "carryOnWeightLimit": " 22 lbs /  10 kg ",
                "checkedBagWeightLimit": "50 lbs / 23 kg "
            },
            "VirginAustralia": {
                "carryOnWeightLimit": " 15 lbs / 7 kg ",
                "checkedBagWeightLimit": " 50 lbs / 23 kg "
            },
            "WestJet": {
                "carryOnWeightLimit": " No weight limit",
                "checkedBagWeightLimit": " 50 lbs / 23 kg "
            }
        };


        function calculateLuggage() {
            const airlineSelect = document.getElementById("airline");
            const airlineName = airlineSelect.options[airlineSelect.selectedIndex].value;
            if (!airlineName) {
                alert("Please select an airline.");
                return false;
            }
            const carryOnWeightLimit = airlines[airlineName].carryOnWeightLimit;
            const checkedBagWeightLimit = airlines[airlineName].checkedBagWeightLimit;
            document.getElementById("airline-name").textContent = airlineName;
            document.getElementById("carry-on-weight-limit").textContent = carryOnWeightLimit;
            document.getElementById("checked-bag-weight-limit").textContent = checkedBagWeightLimit;
            document.querySelector(".output").style.display = "block";
            return false;
        }


        var skiItems = {
            "Skis - Men's (Pair) + Bindings": 5.6,
            "Skis - Women's (Pair) + Bindings": 5.3,
            "Skis - Youth (Pair) + Bindings": 4.5,
            "Snowboard - Women's + Bindings ": 3.6,
            "Snowboard - Youth + Bindings": 2.8,
            "Snowboard - Men's + Bindings": 4.5,
            "4Frnt - MSP 91 - 165 cm": 5.5,
            "4Frnt - MSP 91 - 171 cm": 5.6,
            "4Frnt - MSP 91 - 176 cm": 5.8,
            "4Frnt - MSP 91 - 181 cm": 6,
            "4Frnt - MSP 91 - 187 cm": 6.1,
            "4Frnt - MSP 99 - 171 cm": 6.2,
            "4Frnt - MSP 99 - 176 cm": 6.2,
            "4Frnt - MSP 99 - 181 cm": 6.4,
            "4Frnt - MSP 99 - 187 cm": 6.7,
            "4Frnt - MSP CC - 159 cm": 5.6,
            "4Frnt - MSP CC - 165 cm": 5.8,
            "4Frnt - MSP CC - 171 cm": 6.2,
            "4Frnt - MSP 107 - 171 cm": 6.3,
            "4Frnt - MSP 107 - 176 cm": 6.5,
            "4Frnt - MSP 107 - 181 cm": 6.6,
            "4Frnt - MSP 107 - 187 cm": 6.9,
            "4Frnt - Raven - 170 cm": 5.3,
            "4Frnt - Raven - 177 cm": 5.4,
            "4Frnt - Raven - 184 cm": 5.7,
            "4Frnt - Raven, 190 cm": 5.8,
            "4Frnt - Hoji - 170 cm": 5.6,
            "4Frnt - Hoji - 177 cm": 5.8,
            "4Frnt - Hoji - 184 cm": 6,
            "4Frnt - Hoji - 191 cm": 6.1,
            "4Frnt - Renegade - 177 cm": 5.9,
            "4Frnt - Renegade - 184 cm": 6.1,
            "4Frnt - Renegade - 191 cm": 6.3,
            "4Frnt - Switch - 163 cm": 5,
            "4Frnt - Switch - 170 cm": 5.1,
            "4Frnt - Switch - 177 cm": 5.3,
            "4Frnt - Switch - 184 cm": 5.5,
            "4Frnt - Devastator - 172 cm": 5.6,
            "4Frnt - Devastator - 179 cm": 5.8,
            "4Frnt - Devastator - 186 cm": 6,
            "4Frnt - Inthayne - 181 cm": 5.7,
            "4Frnt - Inthayne - 188 cm": 5.9,
            "4Frnt - Devastator Jr. - 147 cm": 4,
            "4Frnt - Devastator Jr. - 157 cm": 4.2,
            "Armada - ARV 116 JJ - 165 cm": 5.9,
            "Armada - ARV 116 JJ - 175 cm": 6.3,
            "Armada - ARV 116 JJ - 175 cm": 6.5,
            "Armada - ARV 116 JJ - 192 cm": 7,
            "Armada - ARV 106 - 172 cm": 6,
            "Armada - ARV 106 - 180 cm": 6.3,
            "Armada - ARV 106 - 188 cm": 6.6,
            "Armada - ARW 116 VJJ UL - 165 cm": 5,
            "Armada - ARW 116 VJJ UL - 175 cm": 5.2,
            "Armada - ARW 116 VJJ UL - 185 cm": 5.5,
            "Armada - Whitewalker 116 - 185 cm": 5.6,
            "Armada - Whitewalker 116 - 192 cm": 5.9,
            "Armada - Edollo - 164 cm": 5.7,
            "Armada - Edollo - 172 cm": 5.8,
            "Armada - Edollo - 180 cm": 6,
            "Armada - BDOG - 164 cm": 5.6,
            "Armada - BDOG - 172 cm": 5.8,
            "Armada - BDOG - 180 cm": 5.9,
            "Armada - ARG II UL - 187 cm": 6.5,
            "Armada - Stranger - 172 cm": 6,
            "Armada - Stranger - 180 cm": 6.2,
            "Armada - BDOG Edgeless - 164 cm": 5.4,
            "Armada - BDOG Edgeles - 172 cm": 5.6,
            "Armada - BDOG Edgeless - 180 cm": 5.8,
            "Armada - Declivity X 115 - 185 cm": 6.5,
            "Armada - Declivity X 115 - 192 cm": 6.9,
            "Armada - Declivity X 102 - 172 cm": 5.7,
            "Armada - Declivity X 102 - 180 cm": 5.9,
            "Armada - Declivity X 102 - 188 cm": 6.1,
            "Armada - Declivity 88 C - 160 cm": 4.9,
            "Armada - Declivity 88 C - 168 cm": 5.2,
            "Armada - Declivity 88 C - 176 cm": 5.4,
            "Armada - Declivity 88 C - 184 cm": 5.6,
            "Armada - Declivity 82 TI - 166 cm": 5.1,
            "Armada - Declivity 82 TI - 174 cm": 5.4,
            "Armada - Declivity 82 TI - 182 cm": 5.5,
            "Armada - Locator 112 - 166 cm": 4.9,
            "Armada - Locator 112 - 173 cm": 5.1,
            "Armada - Locator 112 - 180 cm": 5.2,
            "Armada - Locator 112 - 187 cm": 5.3,
            "Armada - Locator 104 - 162 cm": 4.3,
            "Armada - Locator 104 - 170 cm": 4.8,
            "Armada - Locator 104 - 178 cm": 4.9,
            "Armada - Locator 104 - 186 cm": 5.1,
            "Armada - Locator 96 - 157 cm": 4.3,
            "Armada - Locator 96 - 164 cm": 4.6,
            "Armada - Locator 96 - 171 cm": 4.7,
            "Armada - Locator 96 - 178 cm": 4.7,
            "Armada - Locator 96 - 185 cm": 5,
            "Armada - Locator 88 - 152 cm": 4.1,
            "Armada - Locator 88 - 162 cm": 4.3,
            "Armada - Locator 88 - 172 cm": 4.5,
            "Armada - Locator 88 - 182 cm": 4.7,
            "Atomic - Bent 85 - 170 cm": 5.5,
            "Atomic - Bent 90 - 175 cm": 5.2,
            "Atomic - Bent 100 - 179 cm": 5.4,
            "Atomic - Bent 110 - 180 cm": 5.5,
            "Atomic - Bent Chetler 120 - 184 cm": 5.6,
            "Atomic - Maverick 88 TI - 184 cm": 5.6,
            "Atomic - Maverick 95 TI - 180 cm": 5.6,
            "Atomic - Maverick 105 CTI - 185 cm": 6.1,
            "Atomic - Maverick 115 CTI - 193 cm": 6.3,
            "Atomic - Maven 93 C - 172 cm": 5.3,
            "Atomic - Maven 103 CTI - 170 cm": 5.2,
            "Atomic - Maven 86 - 169 cm": 4.9,
            "Atomic - Maverick 86 C - 185 cm": 5.4,
            "Black Crows - Navis Freebird - 167 cm": 5.1,
            "Black Crows - Navis Freebird - 173 cm": 5.3,
            "Black Crows - Navis Freebird - 179 cm": 5.5,
            "Black Crows - Navis Freebird - 185 cm": 5.7,
            "Black Crows - Camox Freebird - 157.1 cm": 4.6,
            "Black Crows - Camox Freebird - 164.3 cm": 4.7,
            "Black Crows - Camox Freebird - 171.1 cm": 4.9,
            "Black Crows - Camox Freebird - 178.4 cm": 5.1,
            "Black Crows - Camox Freebird - 183.4 cm": 5.2,
            "Black Crows - Camox Freebird - 188.2 cm": 5.4,
            "Black Crows - Orb Freebird - 155.2 cm": 4.4,
            "Black Crows - Orb Freebird - 161.1 cm": 4.5,
            "Black Crows - Orb Freebird - 167.2 cm": 4.7,
            "Black Crows - Orb Freebird - 173.1 cm": 4.8,
            "Black Crows - Orb Freebird - 179.3 cm": 4.9,
            "Black Crows - Orb Freebird - 184.1 cm": 5,
            "Black Crows - Ova Freebird - 156.1 cm": 4,
            "Black Crows - Ova Freebird - 163.5 cm": 4.1,
            "Black Crows - Ova Freebird - 170.3 cm": 4.3,
            "Black Crows - Ova Freebird - 176 cm": 4.4,
            "Black Crows - Ova Freebird - 182.3 cm": 4.6,
            "Black Crows - Draco Freebird - 175.2 cm": 5.7,
            "Black Crows - Draco Freebird - 181.5 cm": 5.8,
            "Black Crows - Draco Freebird - 189.2 cm": 6.1,
            "Black Crows - Corvus Freebird - 176 cm": 5.7,
            "Black Crows - Corvus Freebird - 183.4 cm": 5.9,
            "Black Crows - Corvus Freebird - 188.2 cm": 6,
            "Black Crows - Mentis Freebird - 157.1 cm": 3.8,
            "Black Crows - Mentis Freebird - 164.3 cm": 4,
            "Black Crows - Mentis Freebird - 171 cm": 4,
            "Black Crows - Mentis Freebird - 178.2 cm": 4.2,
            "Black Crows - Serpo - 168.2 cm": 5.5,
            "Black Crows - Serpo - 174.1 cm": 5.5,
            "Black Crows - Serpo - 180.1 cm": 5.7,
            "Black Crows - Serpo - 186.3 cm": 6,
            "Black Crows - Camox - 168.1 cm": 5.4,
            "Black Crows - Camox - 174.2 cm": 5.5,
            "Black Crows - Camox - 180.4 cm": 5.7,
            "Black Crows - Camox - 186.5 cm": 6,
            "Black Crows - Justis - 171.3 cm": 5.9,
            "Black Crows - Justis - 177.4 cm": 6.1,
            "Black Crows - Justis - 183.1 cm": 6.3,
            "Black Crows - Justis - 189.3 cm": 6.4,
            "Black Crows - Vertis - 170.3 cm": 5.3,
            "Black Crows - Vertis - 175.4 cm": 5.4,
            "Black Crows - Vertis - 180.8": 5.5,
            "Black Crows - Mirus Cor - 168.3 cm": 5.5,
            "Black Crows - Mirus Cor - 173.2 cm": 5.6,
            "Black Crows - Mirus Cor - 178 cm": 5.6,
            "Black Crows - Mirus Cor - 184.2 cm": 5.9,
            "Black Crows - Captis - 172.1 cm": 5.5,
            "Black Crows - Captis - 178.4 cm": 5.6,
            "Black Crows - Captis - 184.3 cm": 5.9,
            "Black Crows - Atris - 172.1 cm": 5.6,
            "Black Crows - Atris - 178.4 cm": 5.9,
            "Black Crows - Atris - 184.3 cm": 6,
            "Black Crows - Atris - 190.2 cm": 6.3,
            "Black Crows - Nocta - 177.6 cm": 5.9,
            "Black Crows - Nocta - 185.5 cm": 6.1,
            "Black Crows - Nocta - 190.6 cm": 6.2,
            "Black Crows - Anima - 176.6 cm": 6.3,
            "Black Crows - Anima - 182.1 cm": 6.5,
            "Black Crows - Anima - 189.2 cm": 6.8,
            "Black Crows - Anima - 194.4 cm": 6.9,
            "Black Crows - Solis - 173.3 cm": 5.3,
            "Black Crows - Solis - 180 cm": 5.6,
            "Black Crows - Corvus - 176.3 cm": 5.7,
            "Black Crows - Corvus - 183.3 cm": 5.9,
            "Black Crows - Corvus - 188.3 cm": 6.3,
            "Black Crows - Corvus - 193.2 cm": 6.4,
            "Black Crows - Vertis Birdie - 152.6 cm": 4.7,
            "Black Crows - Vertis Birdie - 159.3 cm": 5,
            "Black Crows - Vertis Birdie - 169.6 cm": 5.2,
            "Black Crows - Camox Birdie - 153.1 cm": 5,
            "Black Crows - Camox Birdie - 1162.3 cm": 5.2,
            "Black Crows - Camox Birdie - 168.1 cm": 5.4,
            "Black Crows - Camox Birdie - 174.2 cm": 5.5,
            "Black Crows - Captis Birdie - 154.4 cm": 5,
            "Black Crows - Captis Birdie - 160.1 cm": 5.1,
            "Black Crows - Captis Birdie - 166.2 cm": 5.3,
            "Black Crows - Captis Birdie - 172.1 cm": 5.5,
            "Black Crows - Atris Birdie - 160.2 cm": 5.3,
            "Black Crows - Atris Birdie - 166.3 cm": 5.4,
            "Black Crows - Atris Birdie - 172.1 cm": 5.6,
            "Black Crows - Atris Birdie - 178.4 cm": 5.9,
            "Black Crows - Anima Birdie - 176.6 cm": 6.3,
            "Black Crows - Anima Birdie - 182.1 cm": 6.5,
            "Black Crows - Camox Birdie Jr - 139.3 cm": 4.4,
            "Black Crows - Camox Birdie Jr - 149.3 cm": 4.7,
            "Black Crows - Camox Birdie Jr - 157.3 cm": 4.8,
            "Black Crows - Camox Birdie Jr - 164.2 cm": 4.9,
            "Black Crows - Camox Jr - 139.3 cm": 4.4,
            "Black Crows - Camox Jr - 149.3 cm": 4.7,
            "Black Crows - Camox Jr - 157.3 cm": 4.8,
            "Black Crows - Camox Jr - 164.2 cm": 4.9,
            "Black Crows - Camox Jr - 171.1 cm": 5.2,
            "Black Crows - Junius Birdie - 101.1 cm": 3.8,
            "Black Crows - Junius Birdie - 111.1 cm": 3.9,
            "Black Crows - Junius Birdie - 121.1 cm": 4.1,
            "Black Crows - Junius Birdie - 131.1 cm": 4.4,
            "Black Crows - Junius Birdie - 141.1 cm": 4.8,
            "Black Crows - Junius - 101.1 cm": 3.8,
            "Black Crows - Junius - 111.1 cm": 3.9,
            "Black Crows - Junius - 121.1 cm": 4.1,
            "Black Crows - Junius - 131.1 cm": 4.4,
            "Black Crows - Junius - 141.1 cm": 4.8,
            "Black Diamond - Women's Impulse 98 TI - 161 cm": 5.3,
            "Black Diamond - Women's Impulse 98 TI - 168 cm": 5.4,
            "Black Diamond - Women's Impulse 98 TI - 175 cm": 5.5,
            "Black Diamond - Women's Impulse 104 TI - 158 cm": 5.4,
            "Black Diamond - Women's Impulse 104 TI - 165 cm": 5.5,
            "Black Diamond - Women's Impulse 104 TI - 172 cm": 5.7,
            "Black Diamond - Impulse 98 TI - 175 cm": 5.5,
            "Black Diamond - Impulse 98 TI - 182 cm": 5.6,
            "Black Diamond - Impulse 98 TI - 189 cm": 5.9,
            "Black Diamond - Impulse 104 TI - 172 cm": 5.7,
            "Black Diamond - Impulse 104 TI - 179 cm": 5.8,
            "Black Diamond - Impulse 104 TI - 186 cm": 5.9,
            "Black Diamond - Impulse 112 TI - 181 cm": 6.1,
            "Black Diamond - Impulse 112 TI - 186 cm": 6.2,
            "Black Diamond - Impulse Pro 114 TI - 191 cm": 6.5,
            "Black Diamond - Helio Carbon 88 - 152 cm": 4.1,
            "Black Diamond - Helio Carbon 88 - 161 cm": 4.4,
            "Black Diamond - Helio Carbon 88 - 170 cm": 4.6,
            "Black Diamond - Helio Carbon 88 - 179 cm": 4.7,
            "Black Diamond - Helio Carbon 95 - 155 cm": 4.3,
            "Black Diamond - Helio Carbon 95 - 162 cm": 4.5,
            "Black Diamond - Helio Carbon 95 - 169 cm": 4.7,
            "Black Diamond - Helio Carbon 95 - 176 cm": 4.8,
            "Black Diamond - Helio Carbon 95 - 183 cm": 4.9,
            "Black Diamond - Helio Carbon 104 - 160 cm": 4.5,
            "Black Diamond - Helio Carbon 104 - 166 cm": 4.7,
            "Black Diamond - Helio Carbon 104 - 172 cm": 4.8,
            "Black Diamond - Helio Carbon 104 - 178 cm": 4.9,
            "Black Diamond - Helio Carbon 104 - 184 cm": 4.1,
            "Black Diamond - Helio Carbon 115 - 177 cm": 5.1,
            "Black Diamond - Helio Carbon 115 - 185 cm": 5.3,
            "Black Diamond - impulse 98 - 161 cm": 5.3,
            "Black Diamond - impulse 98 - 168 cm": 5.4,
            "Black Diamond - impulse 98 - 175 cm": 5.5,
            "Black Diamond - impulse 98 - 182 cm": 5.6,
            "Black Diamond - impulse 98 - 189 cm": 6,
            "Black Diamond - Impulse 104 - 165 cm": 5.6,
            "Black Diamond - Impulse 104 - 172 cm": 5.7,
            "Black Diamond - Impulse 104 - 179 cm": 5.8,
            "Black Diamond - Impulse 104 - 186 cm": 6,
            "Black Diamond - Impulse 112 - 181 cm": 6.1,
            "Black Diamond - Impulse 112 - 186 cm": 6.2,
            "Blizzard - Anomaly 102 - 176 cm": 6.2,
            "Blizzard - Anomaly 102 - 182 cm": 6.4,
            "Blizzard - Anomaly 102 - 188 cm": 6.5,
            "Blizzard - Anomaly 102 - 192 cm": 6.7,
            "Blizzard - Anomaly 94 - 164 cm": 5.7,
            "Blizzard - Anomaly 94 - 170 cm": 6,
            "Blizzard - Anomaly 94 - 176 cm": 6.2,
            "Blizzard - Anomaly 94 - 182 cm": 6.3,
            "Blizzard - Anomaly 94 - 188 cm": 6.5,
            "Blizzard - Anomaly 88 - 164 cm": 5.7,
            "Blizzard - Anomaly 88 - 170 cm": 5.9,
            "Blizzard - Anomaly 88 - 176 cm": 6,
            "Blizzard - Anomaly 88 - 182 cm": 6.2,
            "Blizzard - Anomaly 88 - 188 cm": 6.4,
            "Blizzard - Anomaly 84 - 164 cm": 5.6,
            "Blizzard - Anomaly 84 - 170 cm": 5.7,
            "Blizzard - Anomaly 84 - 176 cm": 5.9,
            "Blizzard - Anomaly 84 - 182 cm": 6.1,
            "Blizzard - Anomaly 84 - 188 cm": 6.3,
            "Blizzard - Rustler 11 - 168 cm": 5.6,
            "Blizzard - Rustler 11 - 174 cm": 5.8,
            "Blizzard - Rustler 11 - 180 cm": 6,
            "Blizzard - Rustler 11 - 186 cm": 6.2,
            "Blizzard - Rustler 11 - 192 cm": 6.5,
            "Blizzard - Rustler 10 - 162 cm": 5.3,
            "Blizzard - Rustler 10 - 168 cm": 5.4,
            "Blizzard - Rustler 10 - 174 cm": 5.6,
            "Blizzard - Rustler 10 - 180 cm": 5.8,
            "Blizzard - Rustler 10 - 186 cm": 6,
            "Blizzard - Rustler 10 - 192 cm": 6.2,
            "Blizzard - Rustler 9 - 162 cm": 5.2,
            "Blizzard - Rustler 9 - 168 cm": 5.4,
            "Blizzard - Rustler 9 - 174 cm": 5.6,
            "Blizzard - Rustler 9 - 180 cm": 5.8,
            "Blizzard - Rustler 9 - 186 cm": 6,
            "Blizzard - Zero G 105 - 164 cm": 4.6,
            "Blizzard - Zero G 105 - 172 cm": 4.8,
            "Blizzard - Zero G 105 - 180 cm": 5.1,
            "Blizzard - Zero G 105 - 188 cm": 5.3,
            "Blizzard - Zero G 095 - 157 cm": 4.1,
            "Blizzard - Zero G 095 - 164 cm": 4.3,
            "Blizzard - Zero G 095 - 171 cm": 4.4,
            "Blizzard - Zero G 095 - 178 cm": 4.5,
            "Blizzard - Zero G 095 - 185 cm": 4.6,
            "Blizzard - Zero G 085 - 150 cm": 3.8,
            "Blizzard - Zero G 085 - 157 cm": 3.9,
            "Blizzard - Zero G 085 - 164 cm": 4.1,
            "Blizzard - Zero G 085 - 171 cm": 4.2,
            "Blizzard - Zero G 085 - 178 cm": 4.4,
            "Blizzard - Zero G LT 080 - 150 cm": 3.7,
            "Blizzard - Zero G LT 080 - 157 cm": 3.8,
            "Blizzard - Zero G LT 080 - 164 cm": 3.9,
            "Blizzard - Zero G LT 080 - 171 cm": 4,
            "Blizzard - Zero G LT 080 - 178 cm": 4.2,
            "Blizzard - Firebird WRC Race Plate - 170 cm": 5.4,
            "Blizzard - Firebird WRC Race Plate - 175 cm": 5.6,
            "Blizzard - Firebird WRC Race Plate - 180 cm": 5.7,
            "Blizzard - Firebird WRC Race Plate - 185 cm": 5.9,
            "Blizzard - Firebird HRC Race Plate - 160 cm": 5.2,
            "Blizzard - Firebird HRC Race Plate - 165 cm": 5.3,
            "Blizzard - Firebird HRC Race Plate - 170 cm": 5.5,
            "Blizzard - Firebird HRC Race Plate - 175 cm": 5.7,
            "Blizzard - Firebird HRC Race Plate - 180 cm": 5.9,
            "Blizzard - Black Pearl 94 - 152 cm": 5.1,
            "Blizzard - Black Pearl 94 - 158 cm": 5.3,
            "Blizzard - Black Pearl 94 - 164 cm": 5.5,
            "Blizzard - Black Pearl 94 - 170 cm": 5.7,
            "Blizzard - Black Pearl 94 - 176 cm": 5.9,
            "Blizzard - Black Pearl 88 - 146 cm": 4.9,
            "Blizzard - Black Pearl 88 - 152 cm": 5,
            "Blizzard - Black Pearl 88 - 158 cm": 5.2,
            "Blizzard - Black Pearl 88 - 164 cm": 5.4,
            "Blizzard - Black Pearl 88 - 170 cm": 5.5,
            "Blizzard - Black Pearl 88 - 176 cm": 5.7,
            "Blizzard - Black Pearl 84 - 146 cm": 4.8,
            "Blizzard - Black Pearl 84 - 152 cm": 4.9,
            "Blizzard - Black Pearl 84 - 158 cm": 5.1,
            "Blizzard - Black Pearl 84 - 164 cm": 5.3,
            "Blizzard - Black Pearl 84 - 170 cm": 5.5,
            "Blizzard - Black Pearl 84 - 176 cm": 5.7,
            "Blizzard - Sheeva 11 - 168 cm": 5.6,
            "Blizzard - Sheeva 11 - 174 cm": 5.8,
            "Blizzard - Sheeva 11 - 180 cm": 6,
            "Blizzard - Sheeva 9 - 150 cm": 4.8,
            "Blizzard - Sheeva 9 - 156 cm": 5,
            "Blizzard - Sheeva 9 - 162 cm": 5.2,
            "Blizzard - Sheeva 9 - 168 cm": 5.4,
            "Blizzard - Sheeva 9 - 174 cm": 5.6,
            "Blizzard - Rustler Team - 132 cm": 4.1,
            "Blizzard - Rustler Team - 140 cm": 4.2,
            "Blizzard - Rustler Team - 148 cm": 4.5,
            "Blizzard - Rustler Team - 156 cm": 4.8,
            "Blizzard - Rustler Team - 164 cm": 5,
            "Blizzard - Sheeva Team - 132 cm": 4.1,
            "Blizzard - Sheeva Team - 140 cm": 4.2,
            "Blizzard - Sheeva Team - 148 cm": 4.5,
            "Blizzard - Sheeva Team - 156 cm": 4.8,
            "Blizzard - Sheeva Team - 164 cm": 5,
            "Candide - AK 121 - 184 cm": 6,
            "Candide - BC 111 - 186 cm": 5.8,
            "Candide - Resort 101 - 184 cm": 5.6,
            "Coaltion Snow - SOS - 157 cm": 5.6,
            "Coaltion Snow - SOS - 166 cm": 5.8,
            "Coaltion Snow - SOS - 173 cm": 6,
            "Coaltion Snow - SOS - 180 cm": 6.4,
            "Coaltion Snow - Rafiki - 157 cm": 5.1,
            "Coaltion Snow - Rafiki - 164 cm": 5.2,
            "Coaltion Snow - Rafiki - 172 cm": 6.1,
            "Coaltion Snow - Rafiki - 180 cm": 6.2,
            "Coaltion Snow - Rebel - 162 cm": 5.3,
            "Coaltion Snow - Rebel - 168 cm": 5.4,
            "Coaltion Snow - Rebel - 175 cm": 5.8,
            "Coaltion Snow - La Nieve - 162 cm": 5.6,
            "Coaltion Snow - La Nieve - 168 cm": 5.7,
            "Coaltion Snow - La Nieve - 173 cm": 5.7,
            "Coaltion Snow - La Nieve - 180 cm": 5.8,
            "Coaltion Snow - Bliss - 168 cm": 5.3,
            "Coaltion Snow - Bliss - 175 cm": 5.4,
            "DPS - Carbon Wailer 100 - 153 cm": 4.9,
            "DPS - Carbon Wailer 100 - 163 cm": 5,
            "DPS - Carbon Wailer 100 - 171 cm": 5.3,
            "DPS - Carbon Wailer 100 - 179 cm": 5.9,
            "DPS - Carbon Wailer 100 - 184 cm": 6.1,
            "DPS - Carbon Wailer 100 - 189 cm": 6.3,
            "DPS - Carbon Wailer 90 - 157 cm": 5,
            "DPS - Carbon Wailer 90 - 165 cm": 5.3,
            "DPS - Carbon Wailer 90 - 171 cm": 5.5,
            "DPS - Carbon Wailer 90 - 179 cm": 5.8,
            "DPS - Carbon Wailer 90 - 184 cm": 6,
            "DPS - Carbon Wailer 107 - 155 cm": 5.2,
            "DPS - Carbon Wailer 107 - 163 cm": 5.5,
            "DPS - Carbon Wailer 107 - 171 cm": 5.7,
            "DPS - Carbon Wailer 107 - 179 cm": 6,
            "DPS - Carbon Wailer 107 - 184 cm": 6.1,
            "DPS - Carbon Wailer 107 - 189 cm": 6.5,
            "DPS - Carbon Pagoda Tour CFL 90 - 157 cm": 4.2,
            "DPS - Carbon Pagoda Tour CFL 90 - 165 cm": 4.4,
            "DPS - Carbon Pagoda Tour CFL 90 - 171 cm": 4.6,
            "DPS - Carbon Pagoda Tour CFL 90 - 179 cm": 4.6,
            "DPS - Carbon Pagoda Tour CFL 90 - 184 cm": 4.8,
            "DPS - Carbon Pagoda Tour CFL 94 - 157 cm": 4.4,
            "DPS - Carbon Pagoda Tour CFL 94 - 165 cm": 4.6,
            "DPS - Carbon Pagoda Tour CFL 94 - 171 cm": 4.7,
            "DPS - Carbon Pagoda Tour CFL 94 - 178 cm": 4.9,
            "DPS - Carbon Pagoda Tour CFL 94 - 185 cm": 5.1,
            "DPS - Carbon Pagoda Tour CFL 100 - 153 cm": 4.3,
            "DPS - Carbon Pagoda Tour CFL 100 - 163 cm": 4.6,
            "DPS - Carbon Pagoda Tour CFL 100 - 171 cm": 4.7,
            "DPS - Carbon Pagoda Tour CFL 100 - 179 cm": 5,
            "DPS - Carbon Pagoda Tour CFL 100 - 184 cm": 5.1,
            "DPS - Carbon Pagoda Tour CFL 105 - 155 cm": 4.5,
            "DPS - Carbon Pagoda Tour CFL 105 - 163 cm": 4.7,
            "DPS - Carbon Pagoda Tour CFL 105 - 171 cm": 4.9,
            "DPS - Carbon Pagoda Tour CFL 105 - 179 cm": 5.1,
            "DPS - Carbon Pagoda Tour CFL 105 - 184 cm": 5.2,
            "DPS - Carbon Pagoda Tour CFL 112 - 158 cm": 4.6,
            "DPS - Carbon Pagoda Tour CFL 112 - 168 cm": 4.7,
            "DPS - Carbon Pagoda Tour CFL 112 - 178 cm": 5,
            "DPS - Carbon Pagoda Tour CFL 112 - 184 cm": 5.2,
            "DPS - Carbon Pagoda Tour CFL 112 - 189 cm": 5.4,
            "DPS - Carbon Kaizen 100 - 153 cm": 4.9,
            "DPS - Carbon Kaizen 100 - 163 cm": 5.1,
            "DPS - Carbon Kaizen 100 - 171 cm": 5.4,
            "DPS - Carbon Kaizen 100 - 179 cm": 5.7,
            "DPS - Carbon Kaizen 100 - 184 cm": 6,
            "DPS - Carbon Kaizen 100 - 189 cm": 6.2,
            "DPS - Carbon Kaizen 112 - 158 cm": 5.4,
            "DPS - Carbon Kaizen 112 - 168 cm": 5.6,
            "DPS - Carbon Kaizen 112 - 178 cm": 5.7,
            "DPS - Carbon Kaizen 112 - 184 cm": 5.9,
            "DPS - Carbon Kaizen 112 - 189 cm": 6.2,
            "DPS - Carbon Kaizen 105 - 155 cm": 5.2,
            "DPS - Carbon Kaizen 105 - 163 cm": 5.3,
            "DPS - Carbon Kaizen 105 - 171 cm": 5.5,
            "DPS - Carbon Kaizen 105 - 179 cm": 5.7,
            "DPS - Carbon Kaizen 105 - 184 cm": 6,
            "DPS - Carbon Kaizen 105 - 189 cm": 6.2,
            "DPS - Carbon Lotus 124 - 179 cm": 5.8,
            "DPS - Carbon Lotus 124 - 185 cm": 5.9,
            "DPS - Carbon Lotus 124 - 191 cm": 6.2,
            "DPS - Carbon Lotus 117 - 171 cm": 5.4,
            "DPS - Carbon Lotus 117 - 178 cm": 5.6,
            "DPS - Carbon Lotus 117 - 185 cm": 5.8,
            "DPS - Carbon Lotus 117 - 191 cm": 6.1,
            "DPS - Carbon Pagoda Tour 94 - 157 cm": 4.4,
            "DPS - Carbon Pagoda Tour 94 - 165 cm": 4.6,
            "DPS - Carbon Pagoda Tour 94 - 171 cm": 4.7,
            "DPS - Carbon Pagoda Tour 94 - 178 cm": 4.9,
            "DPS - Carbon Pagoda Tour 94 - 185 cm": 5.1,
            "DPS - Koala 103 - 168 cm": 5.6,
            "DPS - Koala 103 - 176 cm": 5.8,
            "DPS - Koala 103 - 184 cm": 6.2,
            "DPS - Koala 103 - 189 cm": 6.4,
            "DPS - Carbon Pagoda Tour 100 - 153 cm": 4.3,
            "DPS - Carbon Pagoda Tour 100 - 163 cm": 4.6,
            "DPS - Carbon Pagoda Tour 100 - 171 cm": 4.7,
            "DPS - Carbon Pagoda Tour 100 - 179 cm": 5,
            "DPS - Carbon Pagoda Tour 100 - 184 cm": 5.1,
            "DPS - Koala 111 - 168 cm": 5.8,
            "DPS - Koala 111 - 176 cm": 6.1,
            "DPS - Koala 111 - 184 cm": 6.4,
            "DPS - Koala 111 - 189 cm": 6.6,
            "DPS - Carbon Pagoda Tour 112 - 158 cm": 4.6,
            "DPS - Carbon Pagoda Tour 112 - 168 cm": 4.7,
            "DPS - Carbon Pagoda Tour 112 - 178 cm": 5,
            "DPS - Carbon Pagoda Tour 112 - 184 cm": 5.2,
            "DPS - Carbon Pagoda Tour 112 - 189 cm": 5.4,
            "DPS - Carbon Pagoda Tour 106 - 155 cm": 4.5,
            "DPS - Carbon Pagoda Tour 106 - 163 cm": 4.7,
            "DPS - Carbon Pagoda Tour 106 - 171 cm": 4.9,
            "DPS - Carbon Pagoda Tour 106 - 179 cm": 5.1,
            "DPS - Carbon Pagoda Tour 106 - 184 cm": 5.2,
            "DPS - 50 Kitchens # 15 - 158 cm": 5,
            "DPS - 51 Kitchens # 15 - 168 cm": 5.3,
            "DPS - 52 Kitchens # 15 - 178 cm": 5.7,
            "DPS - 53 Kitchens # 15 - 184 cm": 5.8,
            "DPS - 54 Kitchens # 15 - 189 cm": 6.2,
            "DPS - Grom 87 - 148 cm": 4.9,
            "DPS - Grom 87 - 158 cm": 5.1,
            "DPS - Grom 99 - 148 cm": 5,
            "DPS - Grom 99 - 158 cm": 5.2,
            "Dynafit - Tigard 114 Touring - 180 cm": 5.7,
            "Dynafit - Tigard 114 Touring - 188 cm": 5.9,
            "Dynafit - Tigard 97 - 158 cm": 4.2,
            "Dynafit - Tigard 97 - 165 cm": 4.4,
            "Dynafit - Tigard 97 - 172 cm": 4.7,
            "Dynafit - Tigard 97 - 179 cm": 4.9,
            "Dynafit - Tigard 97 - 186 cm": 5.1,
            "Dynafit - Ridge 95 - 160 cm": 4.4,
            "Dynafit - Ridge 95 - 168 cm": 4.5,
            "Dynafit - Ridge 95 - 176 cm": 4.7,
            "Dynafit - Ridge 95 - 184 cm": 4.8,
            "Dynafit - Tigard 107 - 171 cm": 5.1,
            "Dynafit - Tigard 107 - 177 cm": 5.2,
            "Dynafit - Tigard 107 - 183 cm": 5.4,
            "Dynafit - Tigard 107 - 189 cm": 5.6,
            "Dynafit - Low Tech 88 - 158 cm": 4.1,
            "Dynafit - Low Tech 88 - 165 cm": 4.2,
            "Dynafit - Low Tech 88 - 172 cm": 4.3,
            "Dynafit - Low Tech 88 - 178 cm": 4.4,
            "Dynafit - Low Tech 88 - 184 cm": 4.6,
            "Dynafit - DNA Touring - 153 cm": 3.3,
            "Dynafit - DNA Touring - 162 cm": 3.4,
            "Dynafit - Mezzalama Touring - 153 cm": 3.5,
            "Dynafit - Mezzalama Touring - 162 cm": 3.6,
            "Dynafit - Radical 107 Touring - 173 cm": 5.1,
            "Dynafit - Radical 107 Touring - 181 cm": 5.4,
            "Dynafit - Radical 107 Touring - 188 cm": 5.6,
            "Dynafit - Free 107 - 173 cm": 5.1,
            "Dynafit - Free 107 - 181 cm": 5.3,
            "Dynafit - Free 107 - 188 cm": 5.5,
            "Dynafit - Free 97 - 163 cm": 4.7,
            "Dynafit - Free 97 - 170 cm": 4.8,
            "Dynafit - Free 97 - 177 cm": 4.9,
            "Dynafit - Blacklight 95 Touring Ski Unisex - 165 cm": 4.3,
            "Dynafit - Blacklight 95 Touring Ski Unisex - 172 cm": 4.4,
            "Dynafit - Blacklight 95 Touring Ski Unisex - 178 cm": 4.6,
            "Dynafit - Blacklight 95 Touring Ski Unisex - 184 cm": 4.8,
            "Dynafit - Blacklight 88 Touring Ski Women - 151 cm": 3.9,
            "Dynafit - Blacklight 88 Touring Ski Women - 158 cm": 4,
            "Dynafit - Blacklight 88 Touring Ski Women - 165 cm": 4.1,
            "Dynafit - Blacklight 88 Touring Ski Women - 172 cm": 4.2,
            "Dynafit - Radical 88 Ski Men - 158 cm": 4.3,
            "Dynafit - Radical 88 Ski Men - 166 cm": 4.5,
            "Dynafit - Radical 88 Ski Men - 174 cm": 4.6,
            "Dynafit - Radical 88 Ski Men - 182 cm": 4.7,
            "Dynafit - Radical 88 Touring Ski Women - 151 cm": 4.2,
            "Dynafit - Radical 88 Touring Ski Women - 158 cm": 4.3,
            "Dynafit - Radical 88 Touring Ski Women - 166 cm": 4.4,
            "Dynafit - Radical 88 Touring Ski Women - 174 cm": 4.6,
            "Dynafit - Blacklight 88 Touring Ski Men - 158 cm": 4.1,
            "Dynafit - Blacklight 88 Touring Ski Men - 165 cm": 4.2,
            "Dynafit - Blacklight 88 Touring Ski Men - 172 cm": 4.3,
            "Dynafit - Blacklight 88 Touring Ski Men - 178 cm": 4.4,
            "Dynafit - Blacklight 88 Touring Ski Men - 184 cm": 4.6,
            "Dynafit - Blacklight 80 Touring Ski Unisex - 151 cm": 3.8,
            "Dynafit - Blacklight 80 Touring Ski Unisex - 158 cm": 3.9,
            "Dynafit - Blacklight 80 Touring Ski Unisex - 165 cm": 4,
            "Dynafit - Blacklight 80 Touring Ski Unisex - 172 cm": 4.1,
            "Dynafit - Blacklight 80 Touring Ski Unisex - 178 cm": 4.3,
            "Dynafit - Blacklight Pro Touring Ski Unisex - 158 cm": 3.7,
            "Dynafit - Blacklight Pro Touring Ski Unisex - 165 cm": 3.8,
            "Dynafit - Blacklight Pro Touring Ski Unisex - 172 cm": 3.9,
            "Dynafit - Blacklight Pro Touring Ski Unisex - 178 cm": 4,
            "Dynafit - Free 97 - 184 cm": 5.1,
            "Dynafit - Youngstar Touring Ski - 120 cm": 3.7,
            "Dynafit - Youngstar Touring Ski - 130 cm": 3.9,
            "Dynafit - Youngstar Touring Ski - 140 cm": 4.2,
            "Dynafit - Youngstar Touring Ski - 150 cm": 4.4,
            "Dynafit - Youngstar Touring Ski - 160 cm": 4.7,
            "Dynastar - M-Free 108 - 162 cm": 4,
            "Dynastar - M-Free 108 - 170 cm": 4.1,
            "Dynastar - M-Free 108 - 178 cm": 4.2,
            "Dynastar - M-Free 108 - 185 cm": 4.2,
            "Dynastar - M-Free 108 - 192 cm": 4.3,
            "Dynastar - M-Free 112 F-Team - 183 cm": 4.2,
            "Dynastar - M-Free 112 F-Team - 190 cm": 4.3,
            "Dynastar - Men's On Piste Skis Speed 963 Xpress - 156 cm": 3.7,
            "Dynastar - Men's On Piste Skis Speed 963 Xpress - 162 cm": 3.7,
            "Dynastar - Men's On Piste Skis Speed 963 Xpress - 168 cm": 3.8,
            "Dynastar - Men's On Piste Skis Speed 963 Xpress - 173 cm": 3.8,
            "Dynastar - Unisex's M-FREE 99 - 171 cm": 3.8,
            "Dynastar - Unisex's M-FREE 99 - 179 cm": 3.9,
            "Dynastar - Unisex's M-FREE 99 - 185 cm": 3.9,
            "Dynastar - Speed Omeglass Master SL R22 - 150 cm": 2.9,
            "Dynastar - Speed Omeglass Master SL R22 - 156 cm": 3,
            "Dynastar - Speed Omeglass Master SL R22 - 165 cm": 3,
            "Dynastar - Speed Omeglass Master SL R22 - 170 cm": 3,
            "Dynastar - M-Pro 100 Ti - 162 cm": 3.7,
            "Dynastar - M-Pro 100 Ti - 170 cm": 3.8,
            "Dynastar - M-Pro 100 Ti - 178 cm": 3.9,
            "Dynastar - M-Pro 100 Ti - 186 cm": 4,
            "Dynastar - M-Cross 88 Konect - 159 cm": 3.9,
            "Dynastar - M-Cross 88 Konect - 168 cm": 4,
            "Dynastar - M-Cross 88 Konect - 176 cm": 4.1,
            "Dynastar - M-Cross 88 Konect - 184 cm": 4.2,
            "Dynastar - Speed Course Master GS R22 - 169 cm": 4.1,
            "Dynastar - Speed Course Master GS R22 - 173 cm": 4.1,
            "Dynastar - Speed Course Master GS R22 - 179 cm": 4.2,
            "Dynastar - Speed Course Master GS R22 - 183 cm": 4.3,
            "Dynastar - M-Tour 100 F-Team OPEN - 162 cm": 3.3,
            "Dynastar - M-Tour 100 F-Team OPEN - 170 cm": 3.3,
            "Dynastar - M-Tour 100 F-Team OPEN - 178 cm": 3.4,
            "Dynastar - M-Tour 100 F-Team OPEN - 186 cm": 3.4,
            "Dynastar - M-Pro 94 TI OPEN - 154 cm": 3.5,
            "Dynastar - M-Pro 94 TI OPEN - 162 cm": 3.6,
            "Dynastar - M-Pro 94 TI OPEN - 170 cm": 3.7,
            "Dynastar - M-Pro 94 TI OPEN - 178 cm": 3.8,
            "Dynastar - M-Pro 94 TI OPEN - 186 cm": 3.9,
            "Dynastar - M-Cross 88 Open - 159 cm": 3.7,
            "Dynastar - M-Cross 88 Open - 168 cm": 3.7,
            "Dynastar - M-Cross 88 Open - 176 cm": 3.8,
            "Dynastar - M-Cross 88 Open - 184 cm": 3.9,
            "Dynastar - Speed Course WC GS R22 - 170 cm": 4,
            "Dynastar - Speed Course WC GS R22 - 175 cm": 4,
            "Dynastar - Speed Course WC GS R22 - 182 cm": 4.1,
            "Dynastar - M-Cross 82 Open - 159 cm": 3.5,
            "Dynastar - M-Cross 82 Open - 168 cm": 3.5,
            "Dynastar - M-Cross 82 Open - 178 cm": 3.6,
            "Dynastar - M-Cross 82 Open - 184 cm": 3.7,
            "Dynastar - Speed Omeglass WC FIS SL Factory 157 R22 - 157 cm": 4.1,
            "Dynastar - M-TOUR 90 OPEN - 157 cm": 3.2,
            "Dynastar - M-TOUR 90 OPEN - 167 cm": 3.3,
            "Dynastar - M-TOUR 90 OPEN - 177 cm": 3.4,
            "Dynastar - M-TOUR 90 OPEN - 185 cm": 3.4,
            "Dynastar - M-TOUR 108 F-TEAM OPEN - 171 cm": 3.4,
            "Dynastar - M-TOUR 108 F-TEAM OPEN - 179 cm": 3.5,
            "Dynastar - M-TOUR 108 F-TEAM OPEN - 187 cm": 3.5,
            "Dynastar - M-VERTICAL 88 OPEN - 156 cm": 3.1,
            "Dynastar - M-VERTICAL 88 OPEN - 164 cm": 3.1,
            "Dynastar - M-VERTICAL 88 OPEN - 172 cm": 3.2,
            "Dynastar - M-VERTICAL 88 OPEN - 180 cm": 3.2,
            "Dynastar - Speed Course WC GS Factory 188 R22 - 188 cm": 4.2,
            "Dynastar - Speed Omeglass WC SL 150 R22 - 150 cm": 4,
            "Dynastar - M-FREE 90 OPEN - 137 cm": 3.2,
            "Dynastar - M-FREE 90 OPEN - 147 cm": 3.3,
            "Dynastar - M-FREE 90 OPEN - 157 cm": 3.4,
            "Dynastar - M-FREE 90 OPEN - 167 cm": 3.4,
            "Dynastar - M-FREE 90 OPEN - 177 cm": 3.5,
            "Dynastar - M-PRO 108 TI F-TEAM 182 OPEN - 182 cm": 4.2,
            "Dynastar - M-PRO 85 OPEN - 158 cm": 3.4,
            "Dynastar - M-PRO 85 OPEN - 167 cm": 3.6,
            "Dynastar - M-PRO 85 OPEN - 176 cm": 3.7,
            "Dynastar - M-PRO 85 OPEN - 185 cm": 3.8,
            "Dynastar - M-PRO 108 TI F-TEAM 192 OPEN - 192 cm": 4.4,
            "Dynastar - E-Cross 88 Open - 150 cm": 3.6,
            "Dynastar - E-Cross 88 Open - 158 cm": 3.7,
            "Dynastar - E-Cross 88 Open - 167 cm": 3.7,
            "Dynastar - E-Cross 88 Open - 175 cm": 3.8,
            "Dynastar - M-Pro W 92 OPEN - 146 cm": 3.5,
            "Dynastar - M-Pro W 92 OPEN - 154 cm": 3.5,
            "Dynastar - M-Pro W 92 OPEN - 162 cm": 3.6,
            "Dynastar - M-Pro W 92 OPEN - 170 cm": 3.7,
            "Dynastar - M-Pro W 92 OPEN - 178 cm": 3.8,
            "Dynastar - E LITE 9 KONECT - 155 cm": 3.7,
            "Dynastar - E LITE 9 KONECT - 160 cm": 3.7,
            "Dynastar - E LITE 9 KONECT - 165 cm": 3.8,
            "Dynastar - E-Cross 82 Open - 150 cm": 3.4,
            "Dynastar - E-Cross 82 Open - 158 cm": 3.5,
            "Dynastar - E-Cross 82 Open - 167 cm": 3.5,
            "Dynastar - E-Cross 82 Open - 175 cm": 3.6,
            "Dynastar - E LITE 8 KONECT - 149 cm": 3.8,
            "Dynastar - E LITE 8 KONECT - 158 cm": 3.9,
            "Dynastar - E LITE 8 KONECT - 166 cm": 3.9,
            "Dynastar - M-PRO W 98 OPEN - 154 cm": 3.6,
            "Dynastar - M-PRO W 98 OPEN - 162 cm": 3.7,
            "Dynastar - M-PRO W 98 OPEN - 170 cm": 3.8,
            "Dynastar - M-PRO W 98 OPEN - 178 cm": 3.9,
            "Dynastar - E LITE 5 XPRESS - 149 cm": 3.4,
            "Dynastar - E LITE 5 XPRESS - 155 cm": 3.5,
            "Dynastar - E LITE 5 XPRESS - 162 cm": 3.6,
            "Dynastar - E LITE 5 XPRESS - 170 cm": 3.6,
            "Dynastar - M-PRO W 85 OPEN - 149 cm": 3.3,
            "Dynastar - M-PRO W 85 OPEN - 158 cm": 3.4,
            "Dynastar - M-PRO W 85 OPEN - 167 cm": 3.6,
            "Dynastar - Speed Omeglass Team SL R21 Pro - 128 cm": 3.5,
            "Dynastar - Speed Omeglass Team SL R21 Pro - 135 cm": 3.6,
            "Dynastar - Speed Omeglass Team SL R21 Pro - 142 cm": 3.7,
            "Dynastar - Speed Omeglass Team SL R21 Pro - 149 cm": 3.8,
            "Dynastar - Speed Course Team GS R21 Pro - 126 cm": 3.1,
            "Dynastar - Speed Course Team GS R21 Pro - 134 cm": 3.2,
            "Dynastar - Speed Course Team GS R21 Pro - 143 cm": 3.3,
            "Dynastar - Speed Course Team GS R21 Pro - 150 cm": 3.4,
            "Dynastar - Speed Course Team GS R21 Pro - 158 cm": 3.5,
            "Dynastar - Speed Course Team GS R21 Pro - 164 cm": 3.6,
            "Dynastar - Speed Course Team GS R21 Pro - 171 cm": 3.7,
            "Dynastar - Team Speed Kid-X - 100 cm": 2.6,
            "Dynastar - Team Speed Kid-X - 110 cm": 2.7,
            "Dynastar - Team Speed Kid-X - 120 cm": 2.8,
            "Dynastar - Team Speed Kid-X - 130 cm": 2.9,
            "Dynastar - Junior On piste skis Team Comp Open - 110 cm": 2.9,
            "Dynastar - Junior On piste skis Team Comp Open - 120 cm": 2.9,
            "Dynastar - Junior On piste skis Team Comp Open - 130 cm": 3,
            "Dynastar - Junior On piste skis Team Comp Open - 140 cm": 3.1,
            "Dynastar - Junior On piste skis Team Comp Open - 150 cm": 3.2,
            "Dynastar - Junior On piste skis Team Comp Open - 160 cm": 3.3,
            "Elan - Ripstick 88 - 154 cm": 4.5,
            "Elan - Ripstick 88 - 161 cm": 4.8,
            "Elan - Ripstick 88 - 168 cm": 4.8,
            "Elan - Ripstick 88 - 175 cm": 5,
            "Elan - Ripstick 88 - 182 cm": 5.2,
            "Elan - Ripstick 88 - 189 cm": 5.4,
            "Elan - Ripstick 96 - 161 cm": 4.8,
            "Elan - Ripstick 96 - 168 cm": 4.8,
            "Elan - Ripstick 96 - 175 cm": 5,
            "Elan - Ripstick 96 - 182 cm": 5.3,
            "Elan - Ripstick 96 - 189 cm": 5.4,
            "Elan - Ripstick 102 - 161 cm": 5.2,
            "Elan - Ripstick 102 - 168 cm": 5.2,
            "Elan - Ripstick 102 - 175 cm": 5.2,
            "Elan - Ripstick 102 - 182 cm": 5.4,
            "Elan - Ripstick 102 - 189 cm": 5.6,
            "Elan - Ripstick 108 - 161 cm": 5,
            "Elan - Ripstick 108 - 168 cm": 5.2,
            "Elan - Ripstick 108 - 175 cm": 5.5,
            "Elan - Ripstick 108 - 182 cm": 5.5,
            "Elan - Ripstick 108 - 189 cm": 5.8,
            "Elan - Ripstick 96 Black Edition - 161 cm": 4.9,
            "Elan - Ripstick 96 Black Edition - 168 cm": 5,
            "Elan - Ripstick 96 Black Edition - 175 cm": 5.1,
            "Elan - Ripstick 96 Black Edition - 182 cm": 5.3,
            "Elan - Ripstick 96 Black Edition - 189 cm": 5.4,
            "Elan - Ripstick 102 Black Edition - 161 cm": 5,
            "Elan - Ripstick 102 Black Edition - 168 cm": 5.1,
            "Elan - Ripstick 102 Black Edition - 175 cm": 5.2,
            "Elan - Ripstick 102 Black Edition - 182 cm": 5.4,
            "Elan - Ripstick 102 Black Edition - 189 cm": 5.6,
            "Elan - Playmaker 111 - 172 cm": 5.4,
            "Elan - Playmaker 111 - 180 cm": 5.6,
            "Elan - Playmaker 111 - 182 cm": 5.8,
            "Elan - Playmaker 101 - 164 cm": 5,
            "Elan - Playmaker 101 - 172 cm": 5.1,
            "Elan - Playmaker 101 - 180 cm": 5.4,
            "Elan - Playmaker 101 - 188 cm": 5.6,
            "Elan - Playmaker 91 - 156 cm": 4.6,
            "Elan - Playmaker 91 - 164 cm": 4.8,
            "Elan - Playmaker 91 - 172 cm": 5,
            "Elan - Playmaker 91 - 180 cm": 5.1,
            "Elan - Playmaker 91 - 188 cm": 5.3,
            "Elan - Ripstick 88 W - 147 cm": 4.5,
            "Elan - Ripstick 88 W - 154 cm": 4.5,
            "Elan - Ripstick 88 W - 161 cm": 4.8,
            "Elan - Ripstick 88 W - 168 cm": 4.8,
            "Elan - Ripstick 88 W - 175 cm": 5,
            "Elan - Ripstick 94 W - 147 cm": 4.6,
            "Elan - Ripstick 94 W - 154 cm": 4.7,
            "Elan - Ripstick 94 W - 161 cm": 4.8,
            "Elan - Ripstick 94 W - 168 cm": 5,
            "Elan - Ripstick 94 W - 175 cm": 5.1,
            "Elan - Ripstick 94 W Black Edition - 147 cm": 4.6,
            "Elan - Ripstick 94 W Black Edition - 154 cm": 4.7,
            "Elan - Ripstick 94 W Black Edition - 161 cm": 4.8,
            "Elan - Ripstick 94 W Black Edition - 168 cm": 5,
            "Elan - Ripstick 94 W Black Edition - 175 cm": 5.1,
            "Elan - Ripstick 106 W - 154 cm": 5,
            "Elan - Ripstick 106 W - 161 cm": 5,
            "Elan - Ripstick 106 W - 168 cm": 5.2,
            "Elan - Ripstick 106 W - 175 cm": 5.5,
            "Elan - Ripstick 100 W - 154 cm": 4.7,
            "Elan - Ripstick 100 W - 161 cm": 5,
            "Elan - Ripstick 100 W - 168 cm": 5.1,
            "Elan - Ripstick 100 W - 175 cm": 5.2,
            "Elan - Playmaker 87 - 136 cm": 4.2,
            "Elan - Playmaker 87 - 146 cm": 4.2,
            "Elan - Playmaker 87 - 156 cm": 4.5,
            "Elan - Playmaker 87 - 166 cm": 4.7,
            "Elan - Playmaker 87 - 176 cm": 5.1,
            "Faction - Le Mogul - 140 cm": 4.7,
            "Faction - Le Mogul - 147 cm": 4.8,
            "Faction - Le Mogul - 155 cm": 4.9,
            "Faction - Le Mogul - 163 cm": 5,
            "Faction - Le Mogul - 171 cm": 5.1,
            "Faction - Le Mogul - 179 cm": 5.2,
            "Faction - Studio Grom - 139 cm": 4.6,
            "Faction - Studio Grom - 149 cm": 4.7,
            "Faction - Studio Grom - 159 cm": 4.8,
            "Faction - Prodigy 0 - 150 cm": 5.2,
            "Faction - Prodigy 0 - 157 cm": 5.3,
            "Faction - Prodigy 0 - 164 cm": 5.4,
            "Faction - Prodigy 0 - 171 cm": 5.5,
            "Faction - Studio Jr - 125 cm": 4.3,
            "Faction - Studio Jr - 135 cm": 4.4,
            "Faction - Studio Jr - 145 cm": 4.5,
            "Faction - Studio Jr - 155 cm": 4.6,
            "Faction - Prodigy 3 Capsule - 164 cm": 5.5,
            "Faction - Prodigy 3 Capsule - 172 cm": 5.7,
            "Faction - Prodigy 3 Capsule - 178 cm": 5.8,
            "Faction - Prodigy 3 Capsule - 184 cm": 6.2,
            "Faction - Prodigy 2 Capsule - 159 cm": 5.2,
            "Faction - Prodigy 2 Capsule - 165 cm": 5.4,
            "Faction - Prodigy 2 Capsule - 171 cm": 5.5,
            "Faction - Prodigy 2 Capsule - 177 cm": 5.6,
            "Faction - Agent 1 - 154 cm": 4.5,
            "Faction - Agent 1 - 162 cm": 4.6,
            "Faction - Agent 1 - 170 cm": 4.7,
            "Faction - Agent 1 - 178 cm": 5,
            "Faction - Agent 1 - 186 cm": 5.1,
            "Faction - Agent 3 - 164 cm": 5.2,
            "Faction - Agent 3 - 172 cm": 5.4,
            "Faction - Agent 3 - 178 cm": 5.5,
            "Faction - Agent 3 - 183 cm": 5.5,
            "Faction - Agent 3 - 188 cm": 5.6,
            "Faction - Prodigy 1 Capsule - 158 cm": 5,
            "Faction - Prodigy 1 Capsule - 164 cm": 5.2,
            "Faction - Prodigy 1 Capsule - 171 cm": 5.3,
            "Faction - Prodigy 1 Capsule - 178 cm": 5.3,
            "Faction - Dancer 3 Orange - 164 cm": 5.8,
            "Faction - Dancer 3 Orange - 172 cm": 5.9,
            "Faction - Dancer 3 Orange - 178 cm": 6.1,
            "Faction - Dancer 3 Orange - 183 cm": 6.2,
            "Faction - Dancer 3 Orange - 188 cm": 6.3,
            "Faction - Dancer 4 Yellow - 179 cm": 6.2,
            "Faction - Dancer 4 Yellow - 185 cm": 6.3,
            "Faction - Dancer 4 Yellow - 191 cm": 6.5,
            "Faction - Dancer 3 Turquoise - 164 cm": 5.8,
            "Faction - Dancer 3 Turquoise - 172 cm": 5.9,
            "Faction - Dancer 3 Turquoise - 178 cm": 6.1,
            "Faction - Dancer 3 Turquoise - 183 cm": 6.2,
            "Faction - Dancer 3 Turquoise - 188 cm": 6.3,
            "Faction - Dancer 2 Purple - 155 cm": 5.2,
            "Faction - Dancer 2 Purple - 163 cm": 5.3,
            "Faction - Dancer 2 Purple - 171 cm": 5.5,
            "Faction - Dancer 2 Purple - 177 cm": 5.6,
            "Faction - Dancer 2 Purple - 182 cm": 5.8,
            "Faction - Dancer 2 Purple - 187 cm": 6,
            "Faction - Dancer 2 Blue - 155 cm": 5.2,
            "Faction - Dancer 2 Blue - 163 cm": 5.3,
            "Faction - Dancer 2 Blue - 171 cm": 5.5,
            "Faction - Dancer 2 Blue - 177 cm": 5.6,
            "Faction - Dancer 2 Blue - 182 cm": 5.8,
            "Faction - Dancer 2 Blue - 187 cm": 6,
            "Faction - Dancer 1 Grey - 154 cm": 4.9,
            "Faction - Dancer 1 Grey - 162 cm": 5.1,
            "Faction - Dancer 1 Grey - 170 cm": 5.3,
            "Faction - Dancer 1 Grey - 178 cm": 5.4,
            "Faction - Dancer 1 Grey - 186 cm": 5.7,
            "Faction - Dancer 1 Pink - 154 cm": 4.9,
            "Faction - Dancer 1 Pink - 162 cm": 5.1,
            "Faction - Dancer 1 Pink - 170 cm": 5.3,
            "Faction - Dancer 1 Pink - 178 cm": 5.4,
            "Faction - Dancer 1 Pink - 186 cm": 5.7,
            "Faction - Prodigy Jr - 103 cm": 4.7,
            "Faction - Prodigy Jr - 113 cm": 4.8,
            "Faction - Prodigy Jr - 123 cm": 4.9,
            "Faction - Prodigy Jr - 133 cm": 5,
            "Faction - Prodigy Jr - 143 cm": 5.1,
            "Faction - Prodigy 4 - 179 cm": 6.1,
            "Faction - Prodigy 4 - 185 cm": 6.4,
            "Faction - Prodigy 4 - 191 cm": 6.6,
            "Faction - Prodigy 1 - 158 cm": 5,
            "Faction - Prodigy 1 - 164 cm": 5.2,
            "Faction - Prodigy 1 - 171 cm": 5.3,
            "Faction - Prodigy 1 - 178 cm": 5.5,
            "Faction - Prodigy 1 - 184 cm": 5.6,
            "Faction - Prodigy 2 - 159 cm": 5.2,
            "Faction - Prodigy 2 - 165 cm": 5.4,
            "Faction - Prodigy 2 - 171 cm": 5.5,
            "Faction - Prodigy 2 - 177 cm": 5.6,
            "Faction - Prodigy 2 - 183 cm": 5.7,
            "Faction - Prodigy 2 - 189 cm": 5.9,
            "Faction - Prodigy 3 - 164 cm": 5.5,
            "Faction - Prodigy 3 - 172 cm": 5.8,
            "Faction - Prodigy 3 - 178 cm": 5.9,
            "Faction - Prodigy 3 - 184 cm": 6.2,
            "Faction - Prodigy 3 - 190 cm": 6.4,
            "Faction - Studio 4 - 176 cm": 6.2,
            "Faction - Studio 4 - 184 cm": 6.5,
            "Faction - Studio 4 - 191 cm": 6.8,
            "Faction - Studio 0 - 162 cm": 4.9,
            "Faction - Studio 0 - 168 cm": 5,
            "Faction - Studio 0 - 172 cm": 5.1,
            "Faction - Studio 0 - 177 cm": 5.2,
            "Faction - Studio 0 - 182 cm": 5.3,
            "Faction - Studio 1 - 164 cm": 5,
            "Faction - Studio 1 - 171 cm": 5.1,
            "Faction - Studio 1 - 178 cm": 5.3,
            "Faction - Studio 1 - 183 cm": 5.4,
            "Faction - Studio 3 - 165 cm": 5.5,
            "Faction - Studio 3 - 172 cm": 5.6,
            "Faction - Studio 3 - 178 cm": 5.8,
            "Faction - Studio 3 - 168 cm": 6,
            "Faction - Studio 3 - 169 cm": 6.2,
            "Faction - Studio 2 - 166 cm": 5.4,
            "Faction - Studio 2 - 173 cm": 5.5,
            "Faction - Studio 2 - 178 cm": 5.6,
            "Faction - Studio 2 - 183 cm": 5.8,
            "Faction - Studio 2 - 188 cm": 5.9,
            "Faction - Mana 3 Eg - 165 cm": 5.5,
            "Faction - Mana 3 Eg - 172 cm": 5.6,
            "Faction - La Machine Grom Pow - 138 cm": 4.4,
            "Faction - La Machine Grom Pow - 147 cm": 4.5,
            "Faction - La Machine Grom Pow - 156 cm": 4.6,
            "Faction - Le Mogul Pro - 171 cm": 5.1,
            "Faction - Le Mogul Pro - 179 cm": 5.2,
            "Faction - Le Split Mono - 182 cm": 9.9,
            "Faction - Le Mono - 182 cm": 8.8,
            "Faction - Le Mono - 190 cm": 8.8,
            "Faction - La Machine 4 - 171 cm": 5.3,
            "Faction - La Machine 4 - 179 cm": 5.4,
            "Faction - La Machine 4 - 185 cm": 5.5,
            "Faction - La Machine 4 - 191 cm": 5.6,
            "Faction - Agen 2X - 155 cm": 4.5,
            "Faction - Agen 2X - 163 cm": 4.7,
            "Faction - Agen 2X - 171 cm": 4.8,
            "Faction - Agent 1X - 154 cm": 4.5,
            "Faction - Agent 1X - 162 cm": 4.6,
            "Faction - Agent 1X - 170 cm": 4.7,
            "Faction - La Machine 5 - 178 cm": 5.8,
            "Faction - La Machine 5 - 186 cm": 5.9,
            "Faction - La Machine 5 - 192 cm": 6,
            "Faction - La Machine 3 - 165 cm": 5,
            "Faction - La Machine 3 - 172 cm": 5,
            "Faction - La Machine 3 - 178 cm": 5.1,
            "Faction - La Machine 3 - 184 cm": 5.2,
            "Faction - La Machine 3 - 190 cm": 5.4,
            "Faction - La Machine 2 - 157 cm": 4.5,
            "Faction - La Machine 2 - 164 cm": 4.6,
            "Faction - La Machine 2 - 171 cm": 4.7,
            "Faction - La Machine 2 - 177 cm": 4.8,
            "Faction - La Machine 2 - 183 cm": 4.9,
            "Faction - La Machine 1 - 156 cm": 4.3,
            "Faction - La Machine 1 - 163 cm": 4.4,
            "Faction - La Machine 1 - 170 cm": 4.5,
            "Faction - La Machine 1 - 177 cm": 4.6,
            "Faction - La Machine 1 - 182 cm": 4.7,
            "Faction - La Machine Grom - 129 cm": 4.3,
            "Faction - La Machine Grom - 138 cm": 4.4,
            "Faction - La Machine Grom - 147 cm": 4.5,
            "Faction - La Machine Grom - 156 cm": 4.6,
            "Faction - Agent 4 - 179 cm": 5.8,
            "Faction - Agent 4 - 185 cm": 5.9,
            "Faction - Agent 4 - 191 cm": 6,
            "Faction - Agent 3X - 164 cm": 5.2,
            "Faction - Agent 3X - 172 cm": 5.4,
            "Faction - Agent 3X - 178 cm": 5.5,
            "Faction - Agent 2 - 155 cm": 4.5,
            "Faction - Agent 2 - 163 cm": 4.7,
            "Faction - Agent 2 - 171 cm": 4.8,
            "Faction - Agent 2 - 177 cm": 5,
            "Faction - Agent 2 - 182 cm": 5.1,
            "Faction - Agent 2 - 187 cm": 5.2,
            "Fischer - RC4 Power": 5.6,
            "Fischer - Ranger - 142 cm": 4.8,
            "Fischer - Ranger - 152 cm": 5,
            "Fischer - Ranger - 162 cm": 5.3,
            "Fischer - Ranger - 172 cm": 5.6,
            "Fischer - Ranger - 182 cm": 5.9,
            "Fischer - Ranger 116 - 180 cm": 6,
            "Fischer - Ranger 116 - 187 cm": 6.3,
            "Fischer - Ranger 116 - 193 cm": 6.6,
            "Fischer - Ranger 108 - 171 cm": 5.7,
            "Fischer - Ranger 108 - 178 cm": 6,
            "Fischer - Ranger 108 - 185 cm": 6.2,
            "Fischer - Ranger 108 - 192 cm": 6.5,
            "Fischer - Ranger 102 - 155 cm": 5,
            "Fischer - Ranger 102 - 162 cm": 5.3,
            "Fischer - Ranger 102 - 169 cm": 5.5,
            "Fischer - Ranger 102 - 176 cm": 5.8,
            "Fischer - Ranger 102 - 183 cm": 6.1,
            "Fischer - Ranger 102 - 190 cm": 6.4,
            "Fischer - Ranger 96 - 159 cm": 5.2,
            "Fischer - Ranger 96 - 166 cm": 5.5,
            "Fischer - Ranger 96 - 173 cm": 5.7,
            "Fischer - Ranger 96 - 180 cm": 5.9,
            "Fischer - Ranger 96 - 187 cm": 6.2,
            "Fischer - Ranger 90 - 156 cm": 5.1,
            "Fischer - Ranger 90 - 163 cm": 5.3,
            "Fischer - Ranger 90 - 170 cm": 5.5,
            "Fischer - Ranger 90 - 177 cm": 5.7,
            "Fischer - Ranger 90 - 184 cm": 5.9,
            "Fischer - Ranger 84 - 153 cm": 4.9,
            "Fischer - Ranger 84 - 160 cm": 5.2,
            "Fischer - Ranger 84 - 167 cm": 5.5,
            "Fischer - Ranger 84 - 174 cm": 5.7,
            "Fischer - Ranger 84 - 181 cm": 5.9,
            "Fischer - Nightstick Team - 135 cm": 4.5,
            "Fischer - Nightstick Team - 145 cm": 4.8,
            "Fischer - Nightstick Team - 155 cm": 4.9,
            "Fischer - Nightstick 90 - 159 cm": 5,
            "Fischer - Nightstick 90 - 168 cm": 5.2,
            "Fischer - Nightstick 90 - 177 cm": 5.4,
            "Fischer - Nightstick 90 - 184 cm": 5.6,
            "Fischer - Nightstick 97 - 163 cm": 5.3,
            "Fischer - Nightstick 97 - 170 cm": 5.5,
            "Fischer - Nightstick 97 - 177 cm": 5.7,
            "Fischer - Nightstick 97 - 184 cm": 5.9,
            "Fischer - Nightstick 104 - 172 cm": 5.6,
            "Fischer - Nightstick 104 - 173 cm": 5.8,
            "Fischer - Nightstick 104 - 174 cm": 6.2,
            "Fischer - Transalp - 134 cm": 4,
            "Fischer - Transalp - 141 cm": 4.2,
            "Fischer - Transalp - 148 cm": 4.3,
            "Fischer - Transalp 92 CTI Pro - 162 cm": 4.3,
            "Fischer - Transalp 92 CTI Pro - 169 cm": 4.4,
            "Fischer - Transalp 92 CTI Pro - 176 cm": 4.5,
            "Fischer - Transalp 92 CTI Pro - 183 cm": 4.6,
            "Fischer - Transalp 86 CTI Pro - 155 cm": 4.1,
            "Fischer - Transalp 86 CTI Pro - 162 cm": 4.2,
            "Fischer - Transalp 86 CTI Pro - 169 cm": 4.3,
            "Fischer - Transalp 86 CTI Pro - 176 cm": 4.4,
            "Fischer - Transalp 86 CTI Pro - 183 cm": 4.5,
            "Fischer - Transalp RC - 151 cm": 3.3,
            "Fischer - Transalp RC - 161 cm": 3.4,
            "Fischer - Transalp 105 CTI - 164 cm": 4.8,
            "Fischer - Transalp 105 CTI - 171 cm": 5,
            "Fischer - Transalp 105 CTI - 178 cm": 5.1,
            "Fischer - Transalp 105 CTI - 185 cm": 5.3,
            "Fischer - Transalp 98 CTI - 155 cm": 4.3,
            "Fischer - Transalp 98 CTI - 162 cm": 4.5,
            "Fischer - Transalp 98 CTI - 169 cm": 4.7,
            "Fischer - Transalp 98 CTI - 176 cm": 4.8,
            "Fischer - Transalp 98 CTI - 183 cm": 5,
            "Fischer - Transalp 86 CTI - 155 cm": 4.1,
            "Fischer - Transalp 86 CTI - 162 cm": 4.2,
            "Fischer - Transalp 86 CTI - 169 cm": 4.4,
            "Fischer - Transalp 86 CTI - 176 cm": 4.5,
            "Fischer - Transalp 86 CTI - 183 cm": 4.6,
            "Fischer - Transalp 86 CTI - 148 cm": 4,
            "G3 -FINDr FLX R3 94 - 154 cm": 4.7,
            "G3 -FINDr FLX R3 94 - 162 cm": 4.8,
            "G3 -FINDr FLX R3 94 - 167 cm": 4.9,
            "G3 -FINDr FLX R3 94 - 172 cm": 5,
            "G3 -FINDr FLX R3 94 - 177 cm": 5.1,
            "G3 -FINDr FLX R3 94 - 182 cm": 5.1,
            "G3 -FINDr FLX R3 94 - 187 cm": 5.2,
            "G3 -FINDr R3 86 - 172 cm": 4.6,
            "G3 -FINDr R3 86 - 177 cm": 4.7,
            "G3 -FINDr R3 86 - 182 cm": 4.8,
            "G3 -FINDr R3 94 - 172 cm": 4.7,
            "G3 -FINDr R3 94 - 177 cm": 4.8,
            "G3 -FINDr R3 94 - 182 cm": 4.9,
            "G3 -FINDr R3 94 - 187 cm": 5,
            "G3 -FINDr R3 102 - 174 cm": 4.9,
            "G3 -FINDr R3 102 - 179 cm": 5,
            "G3 -FINDr R3 102 - 184 cm": 5.1,
            "G3 -FINDr R3 102 - 189 cm": 5.2,
            "G3 -FINDr SWIFT R3 86 - 162 cm": 4.4,
            "G3 -FINDr SWIFT R3 86 - 167 cm": 4.5,
            "G3 -FINDr SWIFT R3 94 - 154 cm": 4.4,
            "G3 -FINDr SWIFT R3 94 - 162 cm": 4.6,
            "G3 -FINDr SWIFT R3 94 - 162 cm": 4.6,
            "G3 -FINDr SWIFT R3 102 - 164 cm": 4.7,
            "G3 -FINDr SWIFT R3 102 - 169 cm": 4.8,
            "G3 -ROAMr R3 100 - 172 cm": 5.4,
            "G3 -ROAMr R3 100 - 177 cm": 5.5,
            "G3 -ROAMr R3 100 - 182 cm": 5.6,
            "G3 -ROAMr R3 100 - 187 cm": 5.7,
            "G3 -ROAMr R3 108 - 171 cm": 5.4,
            "G3 -ROAMr R3 108 - 178 cm": 5.6,
            "G3 -ROAMr R3 108 - 185 cm": 5.8,
            "G3 -ROAMr R3 108 - 192 cm": 6,
            "G3 -ROAMr SWIFT R3 100 - 157 cm": 5.1,
            "G3 -ROAMr SWIFT R3 100 - 167 cm": 5.3,
            "G3 -SEEKr R3 100 - 170 cm": 4.7,
            "G3 -SEEKr R3 100 - 178 cm": 4.9,
            "G3 -SEEKr R3 100 - 186 cm": 5,
            "G3 -SEEKr R3 110 - 172 cm": 4.9,
            "G3 -SEEKr R3 110 - 180 cm": 5.1,
            "G3 -SEEKr R3 110 - 188 cm": 5.2,
            "G3 -SEEKr SWIFT R3 100 - 154 cm": 4.4,
            "G3 -SEEKr SWIFT R3 100 - 162 cm": 4.6,
            "G3 -SEEKr SWIFT R3 110 - 164 cm": 4.8,
            "G3 -SLAYr R3 114 - 170 cm": 5.6,
            "G3 -SLAYr R3 114 - 185 cm": 5.7,
            "G3 -SLAYr R3 114 - 190 cm": 5.9,
            "G3 -SLAYr R3 114 - 195 cm": 6,
            "G3 -SLAYr SWIFT R3 114 - 172 cm": 5.4,
            "Icelantic - Nomad 94 - 162 cm": 5,
            "Icelantic - Nomad 94 - 171 cm": 5.2,
            "Icelantic - Nomad 94 - 176 cm": 5.3,
            "Icelantic - Nomad 94 - 182 cm": 5.4,
            "Icelantic - Nomad 100 - 171 cm": 5.4,
            "Icelantic - Nomad 100 - 176 cm": 5.5,
            "Icelantic - Nomad 100 - 182 cm": 5.6,
            "Icelantic - Nomad 100 - 188 cm": 5.8,
            "Icelantic - Nomad 106 - 171 cm": 5.8,
            "Icelantic - Nomad 106 - 176 cm": 5.7,
            "Icelantic - Nomad 106 - 182 cm": 5.9,
            "Icelantic - Nomad 106 - 188 cm": 6,
            "Icelantic - Nomad 112 - 171 cm": 5.8,
            "Icelantic - Nomad 112 - 176 cm": 6,
            "Icelantic - Nomad 112 - 182 cm": 6.2,
            "Icelantic - Nomad 112 - 188 cm": 6.3,
            "Icelantic - Maiden 95 - 155 cm": 4.9,
            "Icelantic - Maiden 95 - 162 cm": 5.1,
            "Icelantic - Maiden 95 - 169 cm": 5.2,
            "Icelantic - Maiden 102 - 155 cm": 5.1,
            "Icelantic - Maiden 102 - 162 cm": 5.3,
            "Icelantic - Maiden 102 - 169 cm": 5.5,
            "Icelantic - Maiden 102 - 176 cm": 5.7,
            "Icelantic - Maiden 108 - 162 cm": 5.4,
            "Icelantic - Maiden 108 - 169 cm": 5.6,
            "Icelantic - Maiden 108 - 176 cm": 5.8,
            "Icelantic - Saba Pro 107 - 177 cm": 5.7,
            "Icelantic - Saba Pro 107 - 187 cm": 6.2,
            "Icelantic - Saba Pro 117 - 177 cm": 6.3,
            "Icelantic - Saba Pro 117 - 187 cm": 6.6,
            "Icelantic - Nia Pro 105 - 162 cm": 5.5,
            "Icelantic - Nia Pro 105 - 169 cm": 5.6,
            "Icelantic - Nia Pro 105 - 177 cm": 5.9,
            "Icelantic - Pioneer 96 X - 166 cm": 5.5,
            "Icelantic - Pioneer 96 X - 174 cm": 5.6,
            "Icelantic - Pioneer 96 X - 182 cm": 5.9,
            "Icelantic - Pioneer 96 X - 188 cm": 6.1,
            "Icelantic - Pioneer 86 - 166 cm": 5.2,
            "Icelantic - Pioneer 86 - 174 cm": 5.4,
            "Icelantic - Pioneer 86 - 182 cm": 5.5,
            "Icelantic - Pioneer 96 - 166 cm": 5.4,
            "Icelantic - Pioneer 96 - 174 cm": 5.5,
            "Icelantic - Pioneer 96 - 182 cm": 5.8,
            "Icelantic - Pioneer 96 - 188 cm": 5.9,
            "Icelantic - Pioneer 109 - 174 cm": 6,
            "Icelantic - Pioneer 109 - 182 cm": 6.1,
            "Icelantic - Pioneer 109 - 190 cm": 6.4,
            "Icelantic - Shaman 99 - 169 cm": 5.7,
            "Icelantic - Shaman 99 - 176 cm": 5.8,
            "Icelantic - Shaman 99 - 182 cm": 6,
            "Icelantic - Shaman 110 - 169 cm": 5.9,
            "Icelantic - Shaman 110 - 176 cm": 6.1,
            "Icelantic - Shaman 110 - 182 cm": 6.4,
            "Icelantic - Riveter 85 - 150 cm": 4.7,
            "Icelantic - Riveter 85 - 155 cm": 4.8,
            "Icelantic - Riveter 85 - 162 cm": 5,
            "Icelantic - Riveter 85 - 169 cm": 5.1,
            "Icelantic - Riveter 95 - 155 cm": 5.1,
            "Icelantic - Riveter 95 - 162 cm": 5.2,
            "Icelantic - Riveter 95 - 169 cm": 5.3,
            "Icelantic - Natural 101 - 171 cm": 5.2,
            "Icelantic - Natural 101 - 178 cm": 5.4,
            "Icelantic - Natural 101 - 185 cm": 5.6,
            "Icelantic - Mystic 97 - 155 cm": 4.9,
            "Icelantic - Mystic 97 - 162 cm": 5,
            "Icelantic - Mystic 97 - 169 cm": 5.1,
            "Icelantic - Scout 75 - 133 cm": 4,
            "Icelantic - Scout 75 - 143 cm": 4.2,
            "Icelantic - Scout 75 - 153 cm": 4.8,
            "Icelantic - Scout 85 - 133 cm": 4,
            "Icelantic - Scout 85 - 143 cm": 4.2,
            "Icelantic - Scout 85 - 153 cm": 4.6,
            "J Skis - Fastforward - 160 cm": 5.8,
            "J Skis - Fastforward - 167 cm": 5.9,
            "J Skis - Fastforward - 174 cm": 6.1,
            "J Skis - Fastforward - 181 cm": 6.2,
            "J Skis - Fastforward - 187 cm": 6.3,
            "J Skis - Masterblaster - 160 cm": 5.8,
            "J Skis - Masterblaster - 167 cm": 6,
            "J Skis - Masterblaster - 174 cm": 6.1,
            "J Skis - Masterblaster - 181 cm": 6.3,
            "J Skis - Masterblaster - 187 cm": 6.5,
            "J Skis - Hotshot - 170 cm": 6.1,
            "J Skis - Hotshot - 177 cm": 6.5,
            "J Skis - Hotshot - 183 cm": 6.6,
            "J Skis - Hotshot - 189 cm": 6.9,
            "J Skis - Joyride - 140 cm": 4.5,
            "J Skis - Joyride - 150 cm": 4.7,
            "J Skis - Joyride - 160 cm": 5.3,
            "J Skis - Joyride - 167 cm": 5.4,
            "J Skis - Joyride - 175 cm": 5.6,
            "J Skis - Joyride - 182 cm": 5.7,
            "J Skis - Allplay - 158 cm": 5.3,
            "J Skis - Allplay - 165 cm": 5.5,
            "J Skis - Allplay - 172 cm": 5.7,
            "J Skis - Allplay - 179 cm": 5.9,
            "J Skis - Allplay - 186 cm": 6.1,
            "J Skis - Vacation - 166 cm": 5.7,
            "J Skis - Vacation - 173 cm": 5.8,
            "J Skis - Vacation - 180 cm": 6.1,
            "J Skis - Vacation - 186 cm": 6.4,
            "J Skis - Escalator - 162 cm": 5.1,
            "J Skis - Escalator - 169 cm": 5.3,
            "J Skis - Escalator - 176 cm": 5.4,
            "J Skis - Escalator - 182 cm": 5.6,
            "J Skis - Escalator - 188 cm": 5.7,
            "J Skis - Slacker - 169 cm": 5.5,
            "J Skis - Slacker - 176 cm": 5.7,
            "J Skis - Slacker - 182 cm": 5.8,
            "J Skis - Slacker - 188 cm": 6,
            "K2 - Mindbender 116C Women's": 6,
            "K2 - Mindbender 106C Women's": 5.5,
            "K2 - Mindbender 99Ti Women's": 5.8,
            "K2 - Mindbender 96C Women's": 5.3,
            "K2 - Mindbender 90C Women's": 5.1,
            "K2 - Mindbender 89Ti Women's": 5.5,
            "K2 - Mindbender 85 Women's": 4.9,
            "K2 - Mindbender 116C Men's": 6.7,
            "K2 - Mindbender 108Ti Unisex": 6.5,
            "K2 - Mindbender 106C Men's": 6.2,
            "K2 - Mindbender 99Ti Men's": 6.4,
            "K2 - Mindbender 90C Men's": 5.4,
            "K2 - Mindbender 89Ti Men's": 6,
            "K2 - Mindbender 85 Men's": 5.3,
            "K2 - Disruption MTi Women's": 5,
            "K2 - Disruption SC Women's": 4.9,
            "K2 - Disruption 81TI Women's": 5.4,
            "K2 - Disruption 78C Women's": 5.2,
            "K2 - Disruption 76C Women's": 4.8,
            "K2 - Disruption 75 Women's": 4.8,
            "K2 - Disruption MTi Men's": 5.7,
            "K2 - Disruption STi Men's": 5.3,
            "K2 - Disruption SC Men's": 5.2,
            "K2 - Disruption 82Ti Men's": 5.8,
            "K2 - Disruption 78Ti Men's": 5.8,
            "K2 - Disruption 78C Men's": 5.3,
            "K2 - Disruption 76 Men's": 5.2,
            "K2 - K2 Wayback 98 Women's": 4.5,
            "K2 - Wayback 106 Men's": 5,
            "K2 - Wayback 98 Men's": 4.8,
            "K2 - Wayback 89 Men's": 4.6,
            "K2 - Wayback 92 Men's": 5,
            "K2 - Wayback 84 Men's": 4.4,
            "K2 - Reckoner 92 Men's": 5.3,
            "K2 - Reckoner 92 Women's": 5,
            "K2 - Crescendo": 6.2,
            "K2 - Disruption JR": 4,
            "K2 - Mindbender JR": 4.1,
            "K2 - Wayback JR": 3.9,
            "Kastle - RX12 GS - 168 cm": 5.3,
            "Kastle - RX12 GS - 173 cm": 5.4,
            "Kastle - RX12 GS - 178 cm": 5.5,
            "Kastle - RX12 GS - 183 cm": 5.6,
            "Kastle - RX11 - 155 cm": 4.7,
            "Kastle - RX11 - 160 cm": 4.7,
            "Kastle - RX11 - 165 cm": 4.8,
            "Kastle - RX11 - 168 cm": 5,
            "Kastle - RX11 - 173 cm": 5.1,
            "Kastle - RX11 - 178 cm": 5.2,
            "Kastle - MX74 - 150 cm": 5.1,
            "Kastle - MX74 - 157 cm": 5.2,
            "Kastle - MX74 - 164 cm": 5.3,
            "Kastle - MX74 - 171 cm": 5.5,
            "Kastle - MX74 - 178 cm": 5.6,
            "Kastle - MX84 - 155 cm": 5.4,
            "Kastle - MX84 - 162 cm": 5.6,
            "Kastle - MX84 - 169 cm": 5.7,
            "Kastle - MX84 - 176 cm": 5.9,
            "Kastle - MX84 - 183 cm": 6,
            "Kastle - MX88 - 160 cm": 5.5,
            "Kastle - MX88 - 167 cm": 5.7,
            "Kastle - MX88 - 174 cm": 5.8,
            "Kastle - MX88 - 181 cm": 6,
            "Kastle - MX88 - 188 cm": 6.1,
            "Kastle - Biafo 88 - 151 cm": 4.2,
            "Kastle - Biafo 88 - 159 cm": 4.4,
            "Kastle - Biafo 88 - 167 cm": 4.5,
            "Kastle - Pika 94 - 155 cm": 4.6,
            "Kastle - Pika 94 - 163 cm": 4.7,
            "Kastle - Pika 94 - 171 cm": 4.8,
            "Kastle - TX88 - 151 cm": 4.2,
            "Kastle - TX88 - 159 cm": 4.4,
            "Kastle - TX88 - 167 cm": 4.5,
            "Kastle - TX88 - 175 cm": 4.6,
            "Kastle - TX88 - 183 cm": 4.7,
            "Kastle - TX94 - 163 cm": 4.6,
            "Kastle - TX94 - 171 cm": 4.7,
            "Kastle - TX94 - 179 cm": 4.8,
            "Kastle - TX94 - 186 cm": 4.9,
            "Kastle - TX99 - 167 cm": 4.8,
            "Kastle - TX99 - 174 cm": 4.9,
            "Kastle - TX99 - 181 cm": 5.1,
            "Kastle - TX99 - 188 cm": 5.2,
            "Kastle - Paragon 93 - 163 cm": 5.3,
            "Kastle - Paragon 93 - 170 cm": 5.5,
            "Kastle - Paragon 93 - 177 cm": 5.7,
            "Kastle - Paragon 93 - 184 cm": 5.8,
            "Kastle - Paragon 101 - 169 cm": 5.7,
            "Kastle - Paragon 101 - 176 cm": 5.9,
            "Kastle - Paragon 101 - 182 cm": 6,
            "Kastle - Paragon 101 - 190 cm": 6.1,
            "Kastle - Paragon 107 - 168 cm": 5.8,
            "Kastle - Paragon 107 - 178 cm": 6,
            "Kastle - Paragon 107 - 184 cm": 6.1,
            "Kastle - Paragon 107 - 192 cm": 6.3,
            "Kastle - AerialX Jr - 140 cm": 3.7,
            "Kastle - AerialX Summer - 150 cm": 4,
            "Kastle - AerialX Summer - 160 cm": 4.1,
            "Kastle - AerialX - 150 cm": 4.3,
            "Kastle - AerialX - 160 cm": 4.4,
            "Kastle - MogulX Jr - 132 cm": 3.8,
            "Kastle - MogulX Jr - 139 cm": 3.9,
            "Kastle - MogulX Jr - 146 cm": 4.1,
            "Kastle - MogulX Jr - 153 cm": 4.3,
            "Kastle - MogulX Summer - 166 cm": 4.8,
            "Kastle - MogulX Summer - 178 cm": 5.1,
            "Kastle - MogulX - 160 cm": 4.7,
            "Kastle - MogulX - 166 cm": 4.8,
            "Kastle - MogulX - 172 cm": 4.9,
            "Kastle - MogulX - 178 cm": 5.1,
            "Kastle - MogulX - 182 cm": 5.2,
            "La Sportiva - Salto": 4.9,
            "La Sportiva - Tempo": 5.6,
            "La Sportiva - Capo": 6,
            "La Sportiva - Gara Aero LS 70": 3.4,
            "Lib Technologies - Proteen": 5,
            "Lib Technologies - Backwards - 166 cm": 5,
            "Lib Technologies - Backwards - 172 cm": 5.3,
            "Lib Technologies - Backwards - 178 cm": 5.5,
            "Lib Technologies - UFO 95 - 171 cm": 4.8,
            "Lib Technologies - UFO 95 - 178 cm": 5,
            "Lib Technologies - UFO 95 - 185 cm": 5.2,
            "Lib Technologies - UFO 105 - 171 cm": 5.4,
            "Lib Technologies - UFO 105 - 178 cm": 5.5,
            "Lib Technologies - UFO 105 - 185 cm": 5.6,
            "Lib Technologies - Wunderstick 100 - 171 cm": 5.4,
            "Lib Technologies - Wunderstick 100 - 178 cm": 5.7,
            "Lib Technologies - Wunderstick 100 - 185 cm": 5.9,
            "Lib Technologies - Wunderstick 106 - 171 cm": 5.5,
            "Lib Technologies - Wunderstick 106 - 178 cm": 5.8,
            "Lib Technologies - Wunderstick 106 - 185 cm": 6.1,
            "Lib Technologies - Hemi 102 - 171 cm": 5.4,
            "Lib Technologies - Hemi 102 - 178 cm": 5.7,
            "Lib Technologies - Hemi 112 - 171 cm": 39.9,
            "Lib Technologies - Hemi 112 - 178 cm": 5.8,
            "Lib Technologies - Hemi 112 - 185 cm": 6.1,
            "Lib Technologies - Hemi 112 - 192 cm": 6.4,
            "Lib Technologies - Libstick 88 - 153 cm": 4.7,
            "Lib Technologies - Libstick 88 - 160 cm": 4.8,
            "Lib Technologies - Libstick 88 - 167 cm": 5,
            "Lib Technologies - Libstick 98 - 155 cm": 4.9,
            "Lib Technologies - Libstick 98 - 162 cm": 5,
            "Lib Technologies - Libstick 98 - 169 cm": 5.2,
            "Lib Technologies - Libstick 103 ": 5.4,
            "Line - Bacon 108": 6.4,
            "Line - Bacon 115": 6.7,
            "Line - Bacon 122": 6.3,
            "Line - Shorty": 5.3,
            "Line - Blade": 6.1,
            "Line - Blend ": 5.9,
            "Line - Chronic 101": 6.1,
            "Line - Chronic 94": 5.8,
            "Line - Honey Badger": 5,
            "Line - Honey Badger TBL": 5,
            "Line - Optic 104": 5.8,
            "Line - Optic 114": 6.3,
            "Line - Optic 88": 5.4,
            "Line - Optic 96": 5.6,
            "Line - Pandora 106": 6.3,
            "Line - Pandora 85": 5.3,
            "Line - Pandora 92": 5.3,
            "Line - Pandora 99": 5.9,
            "Line - Pescado": 5.9,
            "Line - Ruckus": 4.4,
            "Line - Sakana": 5.5,
            "Line - Vision 104": 5.6,
            "Line - Vision 114": 5.7,
            "Line - Vision 96": 5.4,
            "Majesty - Vandal 95 - 169 cm": 5.2,
            "Majesty - Vandal 95 - 175 cm": 5.3,
            "Majesty - Vandal 95 - 181 cm": 5.5,
            "Majesty - Superwolf 91 - 148 cm": 4.2,
            "Majesty - Superwolf 91 - 154 cm": 4.4,
            "Majesty - Superwolf 91 - 160 cm": 4.6,
            "Majesty - Superwolf 91 - 166 cm": 4.7,
            "Majesty - Superwolf 91 - 172 cm": 4.9,
            "Majesty - Superwolf 91 - 178 cm": 5,
            "Majesty - Superwolf 91 - 184 cm": 5.3,
            "Majesty - Vesper W 90 - 150 cm": 4.5,
            "Majesty - Vesper W 90 - 160 cm": 4.8,
            "Majesty - Vesper W 90 - 166 cm": 4.9,
            "Majesty - Vesper W 90 - 171 cm": 5,
            "Majesty - Vanguard Ti 118 - 170 cm": 5.6,
            "Majesty - Vanguard Ti 118 - 176 cm": 5.9,
            "Majesty - Vanguard Ti 118 - 182 cm": 6.2,
            "Majesty - Vanguard Ti 118 - 188 cm": 6.6,
            "Majesty - Vanguard Ti 118 - 194 cm": 7,
            "Majesty - Vestal W 105 - 162 cm": 5.3,
            "Majesty - Vestal W 105 - 168 cm": 5.4,
            "Majesty - Vestal W 105 - 174 cm": 5.6,
            "Majesty - Vestal W 105 - 180 cm": 5.8,
            "Majesty - Vanguard Carbon 118 - 170 cm": 5.4,
            "Majesty - Vanguard Carbon 118 - 176 cm": 5.5,
            "Majesty - Vanguard Carbon 118 - 182 cm": 5.7,
            "Majesty - Vanguard Carbon 118 - 188 cm": 5.9,
            "Majesty - Vanguard Carbon 118 - 194 cm": 6,
            "Majesty - Dirty Bear Pro 90 - 150 cm": 4.5,
            "Majesty - Dirty Bear Pro 90 - 160 cm": 4.8,
            "Majesty - Dirty Bear Pro 90 - 166 cm": 4.9,
            "Majesty - Dirty Bear Pro 90 - 171 cm": 5,
            "Majesty - Dirty Bear Pro 90 - 176 cm": 5.2,
            "Majesty - Dirty Bear Pro 90 - 181 cm": 5.4,
            "Majesty - Vadera Ti W 110 - 166 cm": 5.3,
            "Majesty - Vadera Ti W 110 - 171 cm": 5.5,
            "Majesty - Vadera Ti W 110 - 176 cm": 5.8,
            "Majesty - Vadera Ti W 110 - 181 cm": 5.9,
            "Majesty - Vadera Carbon W 110 - 166 cm": 5.4,
            "Majesty - Vadera Carbon W 110 - 171 cm": 5.5,
            "Majesty - Vadera Carbon W 110 - 176 cm": 5.7,
            "Majesty - Vadera Carbon W 110 - 181 cm": 5.9,
            "Nordica - Enforcer 104 - 167 cm": 6,
            "Nordica - Enforcer 104 - 173 cm": 6,
            "Nordica - Enforcer 104 - 179 cm": 6.3,
            "Nordica - Enforcer 104 - 185 cm": 6.4,
            "Nordica - Enforcer 104 - 191 cm": 6.9,
            "Nordica - Enforcer 99 - 167 cm": 5.8,
            "Nordica - Enforcer 99 - 173 cm": 6,
            "Nordica - Enforcer 99 - 179 cm": 6.2,
            "Nordica - Enforcer 99 - 185 cm": 6.3,
            "Nordica - Enforcer 99 - 191 cm": 6.7,
            "Nordica - Enforcer 94 - 167 cm": 5.7,
            "Nordica - Enforcer 94 - 173 cm": 5.9,
            "Nordica - Enforcer 94 - 179 cm": 6.2,
            "Nordica - Enforcer 94 - 185 cm": 6.3,
            "Nordica - Enforcer 89 - 167 cm": 5.5,
            "Nordica - Enforcer 89 - 173 cm": 5.8,
            "Nordica - Enforcer 89 - 179 cm": 6,
            "Nordica - Enforcer 89 - 185 cm": 6.3,
            "Nordica - Steadfast 85 - 162 cm": 5.5,
            "Nordica - Steadfast 85 - 168 cm": 5.7,
            "Nordica - Steadfast 85 - 174 cm": 5.9,
            "Nordica - Steadfast 85 - 179 cm": 6.1,
            "Nordica - Unleashed 114 - 174 cm": 5.9,
            "Nordica - Unleashed 114 - 180 cm": 6,
            "Nordica - Unleashed 114 - 186 cm": 6.2,
            "Nordica - Unleashed 114 - 191 cm": 6.4,
            "Nordica - Unleashed 108 - 162 cm": 5.5,
            "Nordica - Unleashed 108 - 168 cm": 5.7,
            "Nordica - Unleashed 108 - 174 cm": 6,
            "Nordica - Unleashed 108 - 180 cm": 6.1,
            "Nordica - Unleashed 108 - 186 cm": 6.2,
            "Nordica - Unleashed 108 - 191 cm": 6.4,
            "Nordica - Unleashed 98 - 156 cm": 5.2,
            "Nordica - Unleashed 98 - 162 cm": 5.2,
            "Nordica - Unleashed 98 - 168 cm": 5.5,
            "Nordica - Unleashed 98 - 178 cm": 5.6,
            "Nordica - Unleashed 98 - 180 cm": 5.7,
            "Nordica - Unleashed 98 - 186 cm": 6.1,
            "Nordica - Unleashed 90 - 144 cm": 4.5,
            "Nordica - Unleashed 90 - 152 cm": 4.7,
            "Nordica - Unleashed 90 - 160 cm": 4.9,
            "Nordica - Unleashed 90 - 168 cm": 5.2,
            "Nordica - Unleashed 90 - 174 cm": 5.3,
            "Nordica - Wild Belle DC 84 - 144 cm": 4.8,
            "Nordica - Wild Belle DC 84 - 150 cm": 5.1,
            "Nordica - Wild Belle DC 84 - 156 cm": 5.2,
            "Nordica - Wild Belle DC 84 - 162 cm": 5.3,
            "Nordica - Wild Belle DC 84 - 168 cm": 5.4,
            "Nordica - Wild Belle 78 CA - 138 cm": 4.3,
            "Nordica - Wild Belle 78 CA - 144 cm": 4.5,
            "Nordica - Wild Belle 78 CA - 150 cm": 4.5,
            "Nordica - Wild Belle 78 CA - 156 cm": 4.7,
            "Nordica - Wild Belle 78 CA - 162 cm": 4.7,
            "Nordica - Wild Belle 78 CA - 168 cm": 4.8,
            "Nordica - Wild Belle 74 - 138 cm": 4.1,
            "Nordica - Wild Belle 74 - 144 cm": 4.4,
            "Nordica - Wild Belle 74 - 150 cm": 4.6,
            "Nordica - Wild Belle 74 - 156 cm": 4.7,
            "Nordica - Wild Belle 74 - 162 cm": 4.9,
            "Nordica - Wild Belle 74 - 168 cm": 5.1,
            "Nordica - Santa Ana 102 - 155 cm": 5.5,
            "Nordica - Santa Ana 102 - 161 cm": 5.7,
            "Nordica - Santa Ana 102 - 167 cm": 5.9,
            "Nordica - Santa Ana 102 - 173 cm": 6,
            "Nordica - Santa Ana 102 - 179 cm": 6.3,
            "Nordica - Santa Ana 92 - 150 cm": 5.2,
            "Nordica - Santa Ana 92 - 155 cm": 5.2,
            "Nordica - Santa Ana 92 - 161 cm": 5.4,
            "Nordica - Santa Ana 92 - 167 cm": 5.6,
            "Nordica - Santa Ana 92 - 173 cm": 5.8,
            "Nordica - Santa Ana 92 - 179 cm": 6.1,
            "Nordica - Santa Ana 87 - 150 cm": 5.2,
            "Nordica - Santa Ana 87 - 155 cm": 5.3,
            "Nordica - Santa Ana 87 - 161 cm": 5.5,
            "Nordica - Santa Ana 87 - 167 cm": 5.8,
            "Nordica - Santa Ana 87 - 173 cm": 5,
            "Nordica - Santa Ana 97 - 150 cm": 5.3,
            "Nordica - Santa Ana 97 - 155 cm": 5.4,
            "Nordica - Santa Ana 97 - 161 cm": 5.5,
            "Nordica - Santa Ana 97 - 167 cm": 5.5,
            "Nordica - Santa Ana 97 - 173 cm": 6,
            "Nordica - Santa Ana 97 - 179 cm": 6.3,
            "RMU - Apostle 106 - 184 cm": 5.8,
            "RMU - Apostle 106 Carbon - 184 cm": 5.4,
            "RMU - Apostle 106 TI - 184 cm": 6,
            "RMU - Apostle 114 - 184 cm": 6.2,
            "RMU - Apostle 114 Carbon - 184 cm": 5.6,
            "RMU - Apostle 96 - 184 cm": 5.6,
            "RMU - Apostle 96 Carbon - 184 cm": 5.2,
            "RMU - Apostle 96 TI - 184 cm": 5.9,
            "RMU - Apostle Jr - 162 cm": 4.9,
            "RMU - Butterknife": 5.9,
            "RMU - Professor 111 - 188 cm": 5.9,
            "RMU - Professor 121 - 188 cm": 6.4,
            "RMU - Rippah - 175 cm": 5.2,
            "RMU - Valhalla 107 - 172 cm": 5.6,
            "RMU - Valhalla 97 - 172 cm": 5.3,
            "RMU - YLE 118 Pro Model - 188 cm": 6.2,
            "RMU - Zephyr - 184 cm": 5.9,
            "Rossignol - Men's Sender 110 - 160 cm": 3.9,
            "Rossignol - Men's Sender 110 - 168 cm": 4,
            "Rossignol - Men's Sender 110 - 176 cm": 4.1,
            "Rossignol - Men's Sender 110 - 184 cm": 4.2,
            "Rossignol - Men's Sender 110 - 191 cm": 4.3,
            "Rossignol - Men's Sender 106 - 180 cm": 4.1,
            "Rossignol - Men's Sender 106 - 187 cm": 4.2,
            "Rossignol - Men's Sender 106 - 194 cm": 4.4,
            "Rossignol - Men's Sender 94 - 156 cm": 3.5,
            "Rossignol - Men's Sender 94 - 164 cm": 3.6,
            "Rossignol - Men's Sender 94 - 172 cm": 3.7,
            "Rossignol - Men's Sender 94 - 178 cm": 3.8,
            "Rossignol - Men's Sender 94 - 186 cm": 3.9,
            "Rossignol - Femme Rallybird 104 - 164 cm": 3.7,
            "Rossignol - Femme Rallybird 104 - 172 cm": 3.8,
            "Rossignol - Femme Rallybird 104 - 178 cm": 3.9,
            "Rossignol - Rallybird 94 - 156 cm": 3.5,
            "Rossignol - Rallybird 94 - 164 cm": 3.6,
            "Rossignol - Rallybird 94 - 172 cm": 3.7,
            "Salomon - MTN 86 Carbon - 148 cm": 3.9,
            "Salomon - MTN 86 Carbon - 156 cm": 4,
            "Salomon - MTN 86 Carbon - 164 cm": 4.1,
            "Salomon - MTN 86 Carbon - 172 cm": 4.3,
            "Salomon - MTN 86 Carbon - 180 cm": 4.5,
            "Salomon - MTN 91 Carbon - 150 cm": 4,
            "Salomon - MTN 91 Carbon - 158 cm": 4.1,
            "Salomon - MTN 91 Carbon - 166 cm": 4.2,
            "Salomon - MTN 91 Carbon - 174 cm": 4.4,
            "Salomon - MTN 91 Carbon - 182 cm": 4.6,
            "Salomon - QST 98 - 169 cm": 5.5,
            "Salomon - QST 98 - 176 cm": 5.7,
            "Salomon - QST 98 - 839 cm": 6,
            "Salomon - QST 98 - 189 cm": 6.2,
            "Salomon - S/Race Prime SL 165 12m": 6.2,
            "Salomon - Stance 90 - 168 cm": 5.4,
            "Salomon - Stance 90 - 176 cm": 5.5,
            "Salomon - Stance 90 - 182 cm": 5.6,
            "Salomon - Stance 90 - 188 cm": 5.8,
            "Salomon - Stance 96 - 168 cm": 5.5,
            "Salomon - Stance 96 - 176 cm": 5.6,
            "Salomon - Stance 96 - 182 cm": 5.8,
            "Salomon - Stance 96 - 188 cm": 6,
            "Salomon - Stance 84 - 161 cm": 4.9,
            "Salomon - Stance 84 - 169 cm": 5,
            "Salomon - Stance 84 - 177 cm": 5.3,
            "Salomon - Stance 84 - 185 cm": 5.4,
            "Salomon - QST Lumen 98 - 152 cm": 5,
            "Salomon - QST Lumen 98 - 160 cm": 5.2,
            "Salomon - QST Lumen 98 - 168 cm": 5.5,
            "Salomon - QST Lumen 98 - 176 cm": 5.7,
            "Salomon - QST 106 - 157 cm": 5.5,
            "Salomon - QST 106 - 165 cm": 5.6,
            "Salomon - QST 106 - 173 cm": 5.8,
            "Salomon - QST 106 - 181 cm": 6,
            "Salomon - QST 106 - 189 cm": 6.2,
            "Volkl - Blaze 86 - 146 cm": 4.4,
            "Volkl - Blaze 86 - 152 cm": 4.5,
            "Volkl - Blaze 86 - 159 cm": 4.6,
            "Volkl - Blaze 86 - 166 cm": 4.8,
            "Volkl - Blaze 86 - 173 cm": 4.9,
            "Volkl - Blaze 86 - 180 cm": 5,
            "Volkl - M7 Mantra - 163 cm": 5.7,
            "Volkl - M7 Mantra - 170 cm": 5.8,
            "Volkl - M7 Mantra - 177 cm": 6.2,
            "Volkl - M7 Mantra - 184 cm": 6.4,
            "Volkl - M7 Mantra - 191 cm": 6.6,
            "Volkl - Secret 96 - 149 cm": 5.3,
            "Volkl - Secret 96 - 156 cm": 5.4,
            "Volkl - Secret 96 - 163 cm": 5.7,
            "Volkl - Secret 96 - 170 cm": 5.8,
            "Volkl - Secret 96 - 177 cm": 6.2,
            "Volkl - Blaze 104 - 158 cm": 4.9,
            "Volkl - Blaze 104 - 165 cm": 5.3,
            "Volkl - Blaze 104 - 172 cm": 5.4,
            "Volkl - Blaze 104 - 179 cm": 5.6,
            "Volkl - Blaze 104 - 186 cm": 5.8,
            "Volkl - Blaze 94 - 151 cm": 4.9,
            "Volkl - Blaze 94 - 158 cm": 5,
            "Volkl - Blaze 94 - 165 cm": 5.1,
            "Volkl - Blaze 94 - 172 cm": 5.2,
            "Volkl - Blaze 94 - 179 cm": 5.4,
            "Volkl - Blaze 94 - 186 cm": 5.6,
            "Zag - SLAP 98 Lady - 160 cm": 5.2,
            "Zag - SLAP 98 Lady - 166 cm": 5.4,
            "Zag - SLAP 98 Lady - 173 cm": 5.4,
            "Zag - SLAP Junior - 137 cm": 4.1,
            "Zag - SLAP Junior - 147 cm": 4.4,
            "Zag - SLAP Junior - 157 cm": 4.7,
            "Zag - SLAP Junior - 167 cm": 4.9,
            "Zag - Adret 78 - 165 cm": 3.9,
            "Zag - Adret 78 - 170 cm": 4,
            "Zag - Adret 78 - 176 cm": 4.2,
            "Zag - SLAP 112 Lady - 164 cm": 5.5,
            "Zag - SLAP 112 Lady - 170 cm": 5.6,
            "Zag - SLAP 112 - 176 cm": 5.7,
            "Zag - SLAP 112 - 182 cm": 5.9,
            "Zag - SLAP 112 - 188 cm": 6,
            "Zag - SLAP 104 Lady - 164 cm": 5.2,
            "Zag - SLAP 104 Lady - 170 cm": 5.6,
            "Zag - SLAP 104 - 170 cm": 5.6,
            "Zag - SLAP 104 - 176 cm": 5.6,
            "Zag - SLAP 104 - 182 cm": 5.9,
            "Zag - SLAP 104 - 188 cm": 6,
            "Zag - H-96 Lady - 156 cm": 5.2,
            "Zag - H-96 Lady - 164 cm": 5.6,
            "Zag - H-96 Lady - 170 cm": 5.3,
            "Zag - H-96 - 170 cm": 4.5,
            "Zag - H-96 - 176 cm": 3.6,
            "Zag - H-96 - 182 cm": 2.8,
            "Zag - H-96 - 188 cm": 4.5,
        };

        var skiItemList = document.getElementById("ski-item-list");
        var skiAddButton = document.getElementById("ski-add-button");
        skiAddButton.addEventListener("click", addSkiItem);
        function addSkiItem() {
            let itemSelect = document.getElementById("ski-item-select");
            let itemName = itemSelect.value;
            console.log("ski item name: ", itemName)
            if (itemName in skiItems) {
                let quantityInput = document.getElementById("ski-quantity");
                let quantity = parseInt(quantityInput.value);
                if (quantity > 0) {
                    var weight = skiItems[itemName] * quantity;
                    var listItem = createListItem(itemName, weight, quantity, 'ski');
                    skiItemList.appendChild(listItem);
                    updateTotalWeight(weight);
                } else {
                    alert("Quantity should be a positive integer.");
                }
            } else {
                alert("Item not found in the database. Please select a valid item.");
            }
        }

        var prevCaseValue=0;
        function addCaseItem(value) {    
          let numberValue=parseFloat(value);
          updateTotalWeight(-prevCaseValue);
          updateTotalWeight(numberValue);
          prevCaseValue=numberValue;
          
        }

        //ADITIONAL ITEMS 
        var itemDatabase = {
            "Base Layer Bottoms": 0.13,
            "Base Layer Top": 0.21,
            "Gloves (Pair)": 0.2,
            "Goggles": 0.23,
            "Helmet": 0.5,
            "Ski Boots (Pair)": 3.6,
            "Ski Poles (Pair)": 0.25,
            "Ski/Snowboard Jacket": 1,
            "Ski/Snowboard Pants": 0.7,
            "Socks": 0.09,
            "Winter Hat": 0.2,
            "Snowboard Boots (Pair)": 2.3,
        };


        var itemList = document.getElementById("item-list");
        var addButton = document.getElementById("add-button");
        var totalWeightElement = document.getElementById("total-weight");
        addButton.addEventListener("click", addItem);
        function addItem() {
            var itemSelect = document.getElementById("item");
            var itemName = itemSelect.value;
            console.log("item name: ", itemName)
            if (itemName in itemDatabase) {
                var quantityInput = document.getElementById("quantity");
                var quantity = parseInt(quantityInput.value);
                if (quantity > 0) {
                    var weight = itemDatabase[itemName] * quantity;
                    var listItem = createListItem(itemName, weight, quantity, 'additional');
                    itemList.appendChild(listItem);
                    updateTotalWeight(weight);
                } else {
                    alert("Quantity should be a positive integer.");
                }
            } else {
                alert("Item not found in the database. Please select a valid item.");
            }
        }
        function createListItem(itemName, weight, quantity, itemType) {
            var listItem = document.createElement("li");
            listItem.classList.add("item");
            var itemNameElement = document.createElement("span");
            itemNameElement.classList.add("item-name");
            itemNameElement.textContent = itemName;
            var quantityElement = document.createElement("span");
            quantityElement.textContent = quantity + " = ";
            var weightElement = document.createElement("span");
            weightElement.textContent = "  " + weight.toFixed(3) + " kg ";
            var removeButton = document.createElement("button");
            removeButton.classList.add("remove-button");
            removeButton.textContent = "Remove";
            removeButton.addEventListener("click", function () {
                removeItem(listItem, weight, itemType);
            });
            listItem.appendChild(itemNameElement);
            listItem.appendChild(quantityElement);
            listItem.appendChild(weightElement);
            listItem.appendChild(removeButton);
            return listItem;
        }
        function removeItem(listItem, weight, itemType) {
          if(itemType=='ski'){
            
            skiItemList.removeChild(listItem);
          }else{
            itemList.removeChild(listItem);
          }
            updateTotalWeight(-weight);
        }
        function updateTotalWeight(weight) {
            var totalWeight = parseFloat(totalWeightElement.textContent);
            totalWeight += weight;
            totalWeightElement.textContent = totalWeight.toFixed(3) + " ";
            var totalWeightInPounds = (totalWeight * 2.205).toFixed(3) + " ";
            document.getElementById("total-weight-pounds").textContent = totalWeightInPounds;
        }
